(() => {
  function initLittleThingsBuilder(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

  const $ = (sel, root = section) => root.querySelector(sel);
  const $$ = (sel, root = section) => Array.from(root.querySelectorAll(sel));
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const preview = $('[data-preview]');
  const previewCanvas = $('[data-preview-canvas]');
  const anchorLayer = $('[data-anchor-layer]');
  const chainImage = $('[data-chain-image]');
  const previewEmpty = $('[data-preview-empty]');
  const countRange = $('[data-count-range]');
  const charmCards = $$('[data-charm]');

  const layouts = {};
  $$('[data-anchor-layout-for]').forEach(script => {
    try {
      const parsed = JSON.parse(script.textContent || 'null');
      layouts[script.dataset.anchorLayoutFor] = Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      layouts[script.dataset.anchorLayoutFor] = null;
    }
  });

  const geometries = {};

  $$('[data-builder-geometry-for]').forEach(script => {
    try {
      const parsed = JSON.parse(script.textContent || 'null');
      geometries[script.dataset.builderGeometryFor] =
        parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      geometries[script.dataset.builderGeometryFor] = null;
    }
  });

  const dragHoldMs = Math.max(
    120,
    Math.min(900, Number(section.dataset.dragHoldMs || 320))
  );

  function inferColor(title, raw) {
    const explicit = String(raw || '').trim();
    if (explicit && clean(explicit) !== 'default') return explicit;

    const t = clean(String(title || '').replace(/[-–—]/g, ' '));

    if (/\b18\s*k\s*rose\s*gold\s*plated\b/.test(t)) return '18K Rose Gold Plated';
    if (/\b14\s*k\s*rose\s*gold\s*plated\b/.test(t)) return '14K Rose Gold Plated';
    if (/\b18\s*k\s*gold\s*plated\b/.test(t)) return '18K Gold Plated';
    if (/\b14\s*k\s*gold\s*plated\b/.test(t)) return '14K Gold Plated';
    if (/\brose\s*gold\s*plated\b/.test(t)) return 'Rose Gold Plated';
    if (/\bgold\s*plated\b/.test(t)) return 'Gold Plated';
    if (t.includes('rose gold')) return 'Rose Gold';
    if (t.includes('silver')) return 'Silver';
    if (t.includes('gold')) return 'Gold';
    if (t.includes('black')) return 'Black';

    return explicit || 'Default';
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function inferStyle(title, raw, type, color) {
    const stripFinishAndType = source => {
      let value = String(source || '');

      [
        /\b\d+\s*k\s*rose\s*gold[-\s]*plated\b/ig,
        /\b\d+\s*k\s*gold[-\s]*plated\b/ig,
        /\brose\s*gold[-\s]*plated\b/ig,
        /\bgold[-\s]*plated\b/ig,
        /\bplated\b/ig
      ].forEach(pattern => {
        value = value.replace(pattern, ' ');
      });

      [
        color,
        'rose gold',
        'gold',
        'silver',
        'black',
        type,
        'bracelet',
        'necklace',
        'anklet'
      ]
        .filter(Boolean)
        .forEach(word => {
          value = value.replace(
            new RegExp(`\\b${escapeRegExp(word)}\\b`, 'ig'),
            ' '
          );
        });

      return value
        .replace(/[-–—_|]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    };

    const explicit = String(raw || '').trim();
    const fromExplicit = stripFinishAndType(explicit);

    if (fromExplicit && clean(fromExplicit) !== clean(title)) {
      return fromExplicit;
    }

    const fromTitle = stripFinishAndType(title);
    return fromTitle || explicit || title;
  }


  function configuredSizeLabel(geometry, fallback = 'Size not set') {
    const pathLength = geometry?.chain?.pathLength;
    const rawValue = String(pathLength?.value ?? '').trim();
    const unit = String(pathLength?.unit || '').trim().toLowerCase();

    if (rawValue && Number.isFinite(Number(rawValue)) && Number(rawValue) > 0) {
      const pretty = Number(Number(rawValue).toFixed(3)).toString();
      const labelUnit =
        unit === 'in'
          ? (Math.abs(Number(rawValue) - 1) < 1e-9 ? 'inch' : 'inches')
          : unit === 'mm'
            ? 'mm'
            : 'cm';
      return `${pretty} ${labelUnit}`;
    }

    return fallback || 'Size not set';
  }

  const bases = $$('[data-base]').map(el => {
    const title = el.dataset.title || '';
    const type = el.dataset.type || 'bracelet';
    const color = inferColor(title, el.dataset.color);
    const variantId = Number(el.dataset.variantId || 0);
    const availableValue = String(el.dataset.available || '').trim().toLowerCase();

    /*
      Shopify should output data-available for every base. During theme/dev
      rendering some previously saved versions of the section can omit that
      attribute. A missing flag must not silently hide a perfectly valid chain.
      If Shopify explicitly says false, keep it unavailable. Otherwise a real
      variant ID is enough to let the base render.
    */
    const available =
      availableValue === 'false'
        ? false
        : availableValue === 'true'
          ? true
          : Number.isFinite(variantId) && variantId > 0;

    const geometry = geometries[el.dataset.productId] || null;

    return {
      type,
      productId: el.dataset.productId,
      variantId,
      handle: el.dataset.handle || '',
      title,
      style: inferStyle(title, el.dataset.style, type, color),
      /*
        V8: the customer-facing size comes from Product Configurator geometry,
        not the legacy lt_chain_size metafield. The metafield remains only as
        a backward-compatible fallback for chains that have not been configured.
      */
      size: configuredSizeLabel(
        geometry,
        'Size not set'
      ),
      color,
      swatchColor: el.dataset.swatch || '',
      anchorCount: Math.max(0, Number(el.dataset.anchorCount || 0)),
      price: Number(el.dataset.price || 0),
      image: el.dataset.image || '',
      available,
      layout: layouts[el.dataset.productId] || null,
      geometry
    };
  });

  const charms = new Map();

  charmCards.forEach(card => {
    const img = $('img', card);

    charms.set(card.dataset.productId, {
      productId: card.dataset.productId,
      variantId: Number(card.dataset.variantId),
      title: card.dataset.title || '',
      price: Number(card.dataset.price || 0),
      image: img ? img.currentSrc || img.src : '',
      searchText: card.dataset.search || '',
      description: card.dataset.description || '',
      vibe: card.dataset.vibe || '',
      meaning: card.dataset.meaning || '',
      language: card.dataset.language || '',
      makeYours: card.dataset.makeYours || '',
      symbol: card.dataset.symbol || '',
      aiKeywords: card.dataset.aiKeywords || '',
      emotionalWorlds: card.dataset.emotionalWorlds || '',
      giftFor: card.dataset.giftFor || '',
      season: card.dataset.season || '',
      charmCollections: card.dataset.charmCollections || '',
      colorFamily: card.dataset.colorFamily || '',
      available: card.dataset.available === 'true',
      collections: String(card.dataset.collections || '').split(/\s+/).filter(Boolean),
      geometry: geometries[card.dataset.productId] || null,
      card
    });
  });

  const assemblyService = {
    variantId: Number(section.dataset.assemblyVariantId || 0),
    price: Number(section.dataset.assemblyPrice || 0),
    title: section.dataset.assemblyTitle || 'Assembly Service',
    available:
      section.dataset.assemblyAvailable === 'true' &&
      Number(section.dataset.assemblyVariantId || 0) > 0
  };

  const hardwareCatalog = (() => {
    const script = $('[data-ltsb-hardware-variants]');
    let parsed = null;

    try {
      parsed = script ? JSON.parse(script.textContent || 'null') : null;
    } catch (error) {
      parsed = null;
    }

    return {
      productId: String(parsed?.productId || ''),
      handle: String(parsed?.handle || 'connectors-clasps'),
      title: String(parsed?.title || section.dataset.hardwareTitle || 'Connectors & Clasps'),
      optionNames: Array.isArray(parsed?.optionNames) ? parsed.optionNames.map(String) : [],
      variants: Array.isArray(parsed?.variants) ? parsed.variants.map(variant => ({
        id: Number(variant?.id || 0),
        title: String(variant?.title || ''),
        available: variant?.available !== false,
        price: Number(variant?.price || 0),
        options: Array.isArray(variant?.options) ? variant.options.map(String) : []
      })) : []
    };
  })();

  function normalizeHardwareColor(value) {
    const text = clean(value).replace(/[-_/]+/g, ' ');
    if (!text) return '';

    if (/\b(silver|stainless|steel|white gold|platinum|rhodium|chrome)\b/.test(text)) {
      return 'silver';
    }

    if (/\b(gold|golden|champagne|brass|rose gold|14k|18k|24k)\b/.test(text)) {
      return 'gold';
    }

    return '';
  }

  function hardwareColorForBase(base = state.base) {
    const geometryColor = normalizeHardwareColor(base?.geometry?.hardwareColor);
    if (geometryColor) return geometryColor;

    return (
      normalizeHardwareColor(base?.color) ||
      normalizeHardwareColor(base?.title) ||
      'gold'
    );
  }

  function hardwareVariantKind(variant) {
    const haystack = clean([
      variant?.title,
      ...(variant?.options || [])
    ].join(' '));

    if (haystack.includes('rounding')) return 'rounding';
    if (haystack.includes('additional')) return 'additional';
    return '';
  }

  function hardwareVariantColor(variant) {
    return normalizeHardwareColor([
      variant?.title,
      ...(variant?.options || [])
    ].join(' '));
  }

  function resolveHardwareVariant(kind, color) {
    const wantedKind = clean(kind);
    const wantedColor = normalizeHardwareColor(color) || 'gold';

    return hardwareCatalog.variants.find(variant => (
      variant &&
      variant.id > 0 &&
      variant.available !== false &&
      hardwareVariantKind(variant) === wantedKind &&
      hardwareVariantColor(variant) === wantedColor
    )) || null;
  }

  function physicalConnectorCount(charm) {
    const configured = Array.isArray(charm?.geometry?.connectors)
      ? charm.geometry.connectors.length
      : 0;

    return Math.max(1, configured || 1);
  }

  const configuredAssemblyDefault = (
    section.dataset.assemblyDefault || 'assembled'
  ).toLowerCase();

  function defaultAssemblyState() {
    if (configuredAssemblyDefault === 'none') return null;
    if (configuredAssemblyDefault === 'loose') return false;
    return assemblyService.available ? true : false;
  }

  const state = {
    type: 'bracelet',
    style: null,
    base: null,
    targetCount: null,
    filter: 'all',
    searchQuery: '',
    modalSearchQuery: '',
    browseMode: String(section.dataset.defaultCharmBrowseMode || 'carousel') === 'grid' ? 'grid' : 'carousel',
    assembly: defaultAssemblyState(),
    assemblyExplicit: false,

    /*
      placements = Array indexed by anchor index.
      Each entry is null OR:
      {
        instanceId,
        productId
      }

      designs = persisted design state for EACH chain/base variant.
      Switching chains never destroys another chain's placements.
    */
    placements: [],
    designs: {},

    dragSource: null,
    pointerDrag: null,
    adding: false,
    anchorDrafts: {}
  };

  const anchorSetupMode = section.dataset.anchorSetup === 'true';
  const redirectToCart = section.dataset.redirectToCart === 'true';
  const previewAssemblyPriceMode =
    (section.dataset.previewAssemblyPriceMode || 'split').toLowerCase();
  const assemblyChoiceRequired = Boolean($('[data-assembly-options]'));

  /*
    Persistent builder state:
    - survives browser refreshes
    - remembers the last active chain
    - remembers each chain independently
    - preserves customer choices while merchant settings stay the same
    - when the merchant changes the assembly default, stale saved assembly
      selections are cleared without deleting the customer's chain/charms
  */
  const STORAGE_VERSION = 2;
  const STORAGE_KEY =
    `little-things-builder:${window.location.host}:${section.dataset.sectionId || 'default'}`;

  let instanceCounter = 0;

  function sizePreviewCanvas() {
    if (!preview || !previewCanvas) return;

    const previewWidth = Math.max(1, preview.clientWidth);
    const previewHeight = Math.max(1, preview.clientHeight);
    const size = Math.max(1, Math.min(previewWidth, previewHeight));

    previewCanvas.style.width = `${size}px`;
    previewCanvas.style.height = `${size}px`;

    /*
      EDGE-SAFE VIEWER
      ----------------
      Do not make the preview taller when charms reach the outside anchors.
      Instead, calculate the largest scale at which the WHOLE design can fit
      inside the existing viewer. Because the scale is applied to the canvas,
      the chain, anchors and charms all shrink together and stay aligned.

      The calculation mirrors .ltsb__placed:
      - horizontal attachment is at 50% of the charm box
      - vertical attachment uses --ltsb-charm-y (14% by default)
    */
    let safeScale = 1;
    const layout = state.base ? anchorLayout() : [];

    if (layout.length) {
      const computed = getComputedStyle(section);
      const charmSize = Math.max(
        0,
        parseFloat(computed.getPropertyValue('--ltsb-charm-size')) || 0
      );

      const rawYOffset = parseFloat(
        computed.getPropertyValue('--ltsb-charm-y')
      );
      const yAttachment = Number.isFinite(rawYOffset)
        ? Math.max(0, Math.min(1, rawYOffset / 100))
        : 0.14;

      /* Keep a small visual breathing room between jewelry and rounded edge. */
      const safePadding = 10;
      const availableX = Math.max(1, previewWidth / 2 - safePadding);
      const availableY = Math.max(1, previewHeight / 2 - safePadding);

      layout.forEach(point => {
        const px = Number(point && point.x);
        const py = Number(point && point.y);
        if (!Number.isFinite(px) || !Number.isFinite(py)) return;

        const anchorX = ((px - 50) / 100) * size;
        const anchorY = ((py - 50) / 100) * size;

        /* Charm is horizontally centered on its anchor. */
        const horizontalExtent = Math.abs(anchorX) + charmSize / 2;
        if (horizontalExtent > 0) {
          safeScale = Math.min(safeScale, availableX / horizontalExtent);
        }

        /* Charm hangs downward from the configured attachment point. */
        const topEdge = anchorY - charmSize * yAttachment;
        const bottomEdge = anchorY + charmSize * (1 - yAttachment);
        const verticalExtent = Math.max(Math.abs(topEdge), Math.abs(bottomEdge));

        if (verticalExtent > 0) {
          safeScale = Math.min(safeScale, availableY / verticalExtent);
        }
      });
    }

    safeScale = Math.max(0.01, Math.min(1, safeScale));
    previewCanvas.style.setProperty('--ltsb-canvas-scale', String(safeScale));
  }

  sizePreviewCanvas();

  if ('ResizeObserver' in window) {
    const previewResizeObserver = new ResizeObserver(sizePreviewCanvas);
    previewResizeObserver.observe(preview);
  } else {
    window.addEventListener('resize', sizePreviewCanvas);
  }

  function setMessage(text = '', error = false) {
    const el = $('[data-message]');
    if (!el) return;

    el.textContent = text;
    el.classList.toggle('is-error', Boolean(error));
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-US',
        {
          style: 'currency',
          currency: section.dataset.currency || 'USD'
        }
      ).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function selectedCount() {
    return state.placements.filter(Boolean).length;
  }

  function quantityForProduct(productId) {
    return state.placements.filter(
      placement => placement && placement.productId === String(productId)
    ).length;
  }

  function charmsTotal() {
    return state.placements.reduce((sum, placement) => {
      if (!placement) return sum;
      const charm = charms.get(String(placement.productId));
      return sum + (charm ? charm.price : 0);
    }, 0);
  }

  function qualifiesForHardware(price) {
  const cents = Math.round(Number(price || 0));

  return (
    Number.isFinite(cents) &&
    cents > 0 &&
    cents % 100 === 99
  );
}

function hardwareRequirementsForDesign() {
  const result = {
    color: hardwareColorForBase(),
    rounding: 0,
    additional: 0
  };

  if (String(section.dataset.currency || '').toUpperCase() !== 'USD') {
    return result;
  }

  if (state.base && qualifiesForHardware(state.base.price)) {
    result.rounding += 1;
  }

  state.placements.forEach(placement => {
    if (!placement) return;

    const charm = charms.get(String(placement.productId));
    if (!charm) return;

    const connectors = physicalConnectorCount(charm);
    const usesRounding = qualifiesForHardware(charm.price);

    if (usesRounding) result.rounding += 1;

    /*
      A charm always consumes one hardware piece per configured connector.
      If the charm ends in .99, ONE of those physical pieces is represented by
      the $0.01 Rounding variant and the remainder use the $0.00 Additional
      variant. This preserves both physical count and price.
    */
    result.additional += Math.max(0, connectors - (usesRounding ? 1 : 0));
  });

  if (
    state.assembly &&
    assemblyService.available &&
    qualifiesForHardware(assemblyService.price)
  ) {
    result.rounding += 1;
  }

  return result;
}

function jewelrySubtotal() {
  return (
    (state.base ? state.base.price : 0) +
    charmsTotal()
  );
}

function totalPrice() {
  const assemblyTotal =
    state.assembly === true && assemblyService.available
      ? assemblyService.price
      : 0;

  /*
   * Builder pricing intentionally excludes Connectors & Clasps.
   * Required hardware remains real cart components and is shown only
   * after the design reaches the cart / checkout.
   */
  return jewelrySubtotal() + assemblyTotal;
}



  function uniqueStyles(type) {
    const result = new Map();

    bases
      .filter(base => base.type === type && base.available)
      .forEach(base => {
        if (!result.has(base.style)) {
          result.set(base.style, base);
        }
      });

    return Array.from(result.entries()).map(([name, sample]) => ({
      name,
      sample
    }));
  }

  function basesForCurrentStyle() {
    return bases.filter(base =>
      base.type === state.type &&
      base.style === state.style &&
      base.available
    );
  }

  function swatch(color, explicitSwatch) {
    const manual = String(explicitSwatch || '').trim();

    if (
      manual &&
      (
        /^#[0-9a-f]{3,8}$/i.test(manual) ||
        (window.CSS && CSS.supports && CSS.supports('color', manual))
      )
    ) {
      return manual;
    }

    const c = clean(color);

    if (c.includes('rose')) return '#d9aaa7';
    if (c.includes('silver') || c.includes('steel')) return '#d6d6d3';
    if (c.includes('black')) return '#282828';
    if (c.includes('white')) return '#f8f5ef';
    if (c.includes('gold')) return '#d8b45e';
    if (c.includes('bronze')) return '#ad7847';

    return '#ddd6ce';
  }



  function unitToMm(value, unit) {
    const number = Number(value);
    if (!Number.isFinite(number) || number <= 0) return 0;

    const normalized = String(unit || 'cm').toLowerCase();
    if (normalized === 'mm') return number;
    if (normalized === 'in') return number * 25.4;
    return number * 10;
  }

  function clamp01(value) {
    return Math.max(0, Math.min(1, Number(value) || 0));
  }

  function pointDistance(a, b) {
    return Math.hypot(
      Number(b?.x || 0) - Number(a?.x || 0),
      Number(b?.y || 0) - Number(a?.y || 0)
    );
  }

  function centripetalCatmullRomPoint(p0, p1, p2, p3, u) {
    const alpha = 0.5;
    const eps = 1e-6;

    const tj = (ti, a, b) =>
      ti + Math.pow(Math.max(eps, pointDistance(a, b)), alpha);

    const t0 = 0;
    const t1 = tj(t0, p0, p1);
    const t2 = tj(t1, p1, p2);
    const t3 = tj(t2, p2, p3);
    const t = t1 + (t2 - t1) * u;

    const lerpT = (a, b, ta, tb, target) => {
      const denom = Math.max(eps, tb - ta);
      const wa = (tb - target) / denom;
      const wb = (target - ta) / denom;

      return {
        x: a.x * wa + b.x * wb,
        y: a.y * wa + b.y * wb
      };
    };

    const A1 = lerpT(p0, p1, t0, t1, t);
    const A2 = lerpT(p1, p2, t1, t2, t);
    const A3 = lerpT(p2, p3, t2, t3, t);
    const B1 = lerpT(A1, A2, t0, t2, t);
    const B2 = lerpT(A2, A3, t1, t3, t);
    const C = lerpT(B1, B2, t1, t2, t);

    return {
      x: clamp01(C.x),
      y: clamp01(C.y)
    };
  }

  function sampleGeometryPath(base = state.base, samplesPerSegment = 24) {
    const geometry = base?.geometry;
    const chain = geometry?.chain;
    const controls = Array.isArray(chain?.path)
      ? chain.path
          .map(point => ({
            x: Number(point?.x),
            y: Number(point?.y)
          }))
          .filter(point =>
            Number.isFinite(point.x) &&
            Number.isFinite(point.y)
          )
      : [];

    if (controls.length < 2) return [];

    const closed = Boolean(chain?.closed);
    if (controls.length === 2) {
      return controls.map(point => ({ ...point }));
    }

    const result = [];
    const n = controls.length;
    const segmentCount = closed ? n : n - 1;

    const extrapolate = (a, b) => ({
      x: clamp01(a.x * 2 - b.x),
      y: clamp01(a.y * 2 - b.y)
    });

    for (let i = 0; i < segmentCount; i++) {
      const p1 = controls[i % n];
      const p2 = controls[(i + 1) % n];

      const p0 = closed
        ? controls[(i - 1 + n) % n]
        : i === 0
          ? extrapolate(p1, p2)
          : controls[i - 1];

      const p3 = closed
        ? controls[(i + 2) % n]
        : i + 2 >= n
          ? extrapolate(p2, p1)
          : controls[i + 2];

      for (let step = 0; step < samplesPerSegment; step++) {
        result.push(
          centripetalCatmullRomPoint(
            p0,
            p1,
            p2,
            p3,
            step / samplesPerSegment
          )
        );
      }
    }

    if (closed && result.length) result.push({ ...result[0] });
    else result.push({ ...controls[n - 1] });

    return result;
  }

  function pathPointAtT(pathT, base = state.base) {
    const path = sampleGeometryPath(base);
    if (!path.length) return null;
    if (path.length === 1) return { ...path[0], pathT: 0 };

    const t = clamp01(pathT);
    const scaled = t * (path.length - 1);
    const index = Math.min(path.length - 2, Math.floor(scaled));
    const local = scaled - index;
    const a = path[index];
    const b = path[index + 1];

    return {
      x: a.x + (b.x - a.x) * local,
      y: a.y + (b.y - a.y) * local,
      pathT: t
    };
  }

  function chainCenter(base = state.base) {
    const path = sampleGeometryPath(base);
    if (!path.length) return { x: .5, y: .5 };

    return path.reduce(
      (sum, point) => ({
        x: sum.x + point.x / path.length,
        y: sum.y + point.y / path.length
      }),
      { x: 0, y: 0 }
    );
  }

  function chainTangentAngle(pathT, base = state.base) {
    const epsilon = .004;
    const before = pathPointAtT(Math.max(0, pathT - epsilon), base);
    const after = pathPointAtT(Math.min(1, pathT + epsilon), base);

    if (!before || !after) return 0;

    return Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI;
  }

  function charmVisualCenter(charm) {
    const points = [];

    [charm?.geometry?.width, charm?.geometry?.height].forEach(measurement => {
      if (!measurement?.a || !measurement?.b) return;

      const ax = Number(measurement.a.x);
      const ay = Number(measurement.a.y);
      const bx = Number(measurement.b.x);
      const by = Number(measurement.b.y);

      if (![ax, ay, bx, by].every(Number.isFinite)) return;

      points.push({
        x: (ax + bx) / 2,
        y: (ay + by) / 2
      });
    });

    if (!points.length) return { x: .5, y: .5 };

    return points.reduce(
      (sum, point) => ({
        x: sum.x + point.x / points.length,
        y: sum.y + point.y / points.length
      }),
      { x: 0, y: 0 }
    );
  }

  function angleDegrees(dx, dy) {
    return Math.atan2(dy, dx) * 180 / Math.PI;
  }

  function normalizedRotation(angle) {
    let value = Number(angle || 0) % 360;
    if (value > 180) value -= 360;
    if (value <= -180) value += 360;
    return value;
  }

  function outwardNormalAngle(pathT) {
    const point = pathPointAtT(pathT);
    if (!point) return 90;

    const tangent = chainTangentAngle(pathT);
    const center = chainCenter();

    const candidateA = tangent + 90;
    const candidateB = tangent - 90;

    const score = angle => {
      const radians = angle * Math.PI / 180;
      const nx = Math.cos(radians);
      const ny = Math.sin(radians);

      return (
        nx * (point.x - center.x) +
        ny * (point.y - center.y)
      );
    };

    return score(candidateA) >= score(candidateB)
      ? candidateA
      : candidateB;
  }

  function outwardCharmRotation(pathT, charm) {
    const point = pathPointAtT(pathT);
    if (!point) return Number(charm?.geometry?.rotationOffset || 0);

    const connectors = Array.isArray(charm?.geometry?.connectors)
      ? charm.geometry.connectors
          .map(point => ({
            x: Number(point?.x),
            y: Number(point?.y)
          }))
          .filter(point => Number.isFinite(point.x) && Number.isFinite(point.y))
      : [];

    const visualCenter = charmVisualCenter(charm);
    const correction = Number(charm?.geometry?.rotationOffset || 0);

    /*
      ONE CONNECTOR
      -------------
      The meaningful intrinsic direction is NOT the image's +X axis.
      It is the vector from the connector hole into the body of the charm.

      Example: a heart with its loop on top has an intrinsic direction of
      roughly +90deg (downward in screen coordinates). At the bottom of a
      necklace the outward normal is also +90deg, so the correct rotation is
      ~0deg — the heart remains visually upright while hanging outward.
    */
    if (connectors.length < 2) {
      const connector = connectors[0] || primaryCharmConnector(charm);
      const bodyAngle = angleDegrees(
        visualCenter.x - connector.x,
        visualCenter.y - connector.y
      );

      const outward = outwardNormalAngle(pathT);

      return normalizedRotation(
        outward - bodyAngle + correction
      );
    }

    /*
      TWO OR MORE CONNECTORS
      ----------------------
      Align the connector baseline to the local chain tangent. Then choose the
      180deg orientation whose charm body sits on the outward side of the
      chain. This prepares the storefront for multi-connector charms without
      needing customer-controlled rotation.
    */
    const a = connectors[0];
    const b = connectors[1];
    const connectorMid = {
      x: (a.x + b.x) / 2,
      y: (a.y + b.y) / 2
    };

    const intrinsicBaseline = angleDegrees(
      b.x - a.x,
      b.y - a.y
    );

    const tangent = chainTangentAngle(pathT);
    const baseRotation = tangent - intrinsicBaseline;

    const bodyVector = {
      x: visualCenter.x - connectorMid.x,
      y: visualCenter.y - connectorMid.y
    };

    const outward = outwardNormalAngle(pathT);

    const bodyScore = rotation => {
      const radians = rotation * Math.PI / 180;
      const rx =
        bodyVector.x * Math.cos(radians) -
        bodyVector.y * Math.sin(radians);
      const ry =
        bodyVector.x * Math.sin(radians) +
        bodyVector.y * Math.cos(radians);

      const outRadians = outward * Math.PI / 180;
      return (
        rx * Math.cos(outRadians) +
        ry * Math.sin(outRadians)
      );
    };

    const flipped = baseRotation + 180;
    const chosen =
      bodyScore(baseRotation) >= bodyScore(flipped)
        ? baseRotation
        : flipped;

    return normalizedRotation(chosen + correction);
  }

  function pathTInZone(pathT, zone) {
    const t = clamp01(pathT);
    const start = clamp01(zone?.startT);
    const end = clamp01(zone?.endT);

    if (start <= end) return t >= start && t <= end;
    return t >= start || t <= end;
  }

  function medianPositive(values) {
    const list = (values || [])
      .map(Number)
      .filter(value => Number.isFinite(value) && value > 0)
      .sort((a, b) => a - b);

    if (!list.length) return 0;
    const middle = Math.floor(list.length / 2);
    return list.length % 2
      ? list[middle]
      : (list[middle - 1] + list[middle]) / 2;
  }

  /*
    Product Configurator displays link-to-link joints as generated red zones,
    but those generated zones are intentionally not duplicated into
    geometry.chain.protectedZones. The storefront therefore rebuilds the same
    joint zones from the saved physical link centers.

    Result: a charm can attach INSIDE a real link, never at the connection
    between two links.
  */
  function generatedLinkJointZones(base = state.base) {
    const chain = base?.geometry?.chain;
    const centers = Array.isArray(chain?.linkCenters)
      ? chain.linkCenters
          .map(center => ({
            pathT: Number(center?.pathT)
          }))
          .filter(center => Number.isFinite(center.pathT))
          .sort((a, b) => a.pathT - b.pathT)
      : [];

    if (
      chain?.autoProtectLinkJoints === false ||
      centers.length < 2
    ) {
      return [];
    }

    const closed = Boolean(chain?.closed);
    const safeFraction = Math.max(
      0.06,
      Math.min(
        0.46,
        Number(chain?.linkJointProtectionFraction || 0.24)
      )
    );

    const pairCount = closed ? centers.length : centers.length - 1;
    const gaps = [];

    for (let i = 0; i < pairCount; i++) {
      const left = centers[i];
      const right =
        i === centers.length - 1 ? centers[0] : centers[i + 1];

      const gap =
        i === centers.length - 1 && closed
          ? 1 - left.pathT + right.pathT
          : right.pathT - left.pathT;

      if (gap > 0.0001) gaps.push(gap);
    }

    const normalGap = medianPositive(gaps);
    const zones = [];

    for (let i = 0; i < pairCount; i++) {
      const left = centers[i];
      const right =
        i === centers.length - 1 ? centers[0] : centers[i + 1];

      const gap =
        i === centers.length - 1 && closed
          ? 1 - left.pathT + right.pathT
          : right.pathT - left.pathT;

      if (!(gap > 0.0001)) continue;

      /* A very large gap usually means a missing detected link. Do not turn
         the middle of that gap into one giant no-charm zone. */
      if (normalGap > 0 && gap > normalGap * 1.45) continue;

      let midpoint = left.pathT + gap / 2;
      if (closed) midpoint = ((midpoint % 1) + 1) % 1;
      else midpoint = clamp01(midpoint);

      const halfWidth = gap * safeFraction / 2;
      const wrap = value => ((value % 1) + 1) % 1;

      zones.push({
        startT: closed
          ? wrap(midpoint - halfWidth)
          : clamp01(midpoint - halfWidth),
        endT: closed
          ? wrap(midpoint + halfWidth)
          : clamp01(midpoint + halfWidth),
        reason: 'link-to-link connection'
      });
    }

    return zones;
  }

  function pathTIsLegal(pathT, base = state.base) {
    const chain = base?.geometry?.chain;
    if (!chain) return true;

    const protectedZones = [
      ...(Array.isArray(chain.protectedZones)
        ? chain.protectedZones
        : []),
      ...generatedLinkJointZones(base)
    ];

    if (protectedZones.some(zone => pathTInZone(pathT, zone))) {
      return false;
    }

    if (chain.restrictToAllowedZones) {
      const allowedZones = Array.isArray(chain.allowedZones)
        ? chain.allowedZones
        : [];

      /*
        A restricted chain with no allowed zones is intentionally NOT
        placeable. This prevents a necklace that still needs its front area
        configured from silently accepting charms everywhere.
      */
      if (
        !allowedZones.length ||
        !allowedZones.some(zone => pathTInZone(pathT, zone))
      ) {
        return false;
      }
    }

    return true;
  }

  function physicalChainLengthMm(base = state.base) {
    return unitToMm(
      base?.geometry?.chain?.pathLength?.value,
      base?.geometry?.chain?.pathLength?.unit
    );
  }

  function physicalChainLinkWidthMm(base = state.base) {
    const explicit = unitToMm(
      base?.geometry?.chain?.linkWidth?.value,
      base?.geometry?.chain?.linkWidth?.unit
    );

    if (explicit > 0) return explicit;

    return Math.max(
      0,
      Number(base?.geometry?.chain?.detectedLinkLengthMm || 0)
    );
  }

  function physicalChainLinkHeightMm(base = state.base) {
    const explicit = unitToMm(
      base?.geometry?.chain?.linkHeight?.value,
      base?.geometry?.chain?.linkHeight?.unit
    );

    if (explicit > 0) return explicit;

    return Math.max(
      0,
      Number(base?.geometry?.chain?.detectedLinkWidthMm || 0)
    );
  }

  function physicalCharmWidthMm(charm) {
    return unitToMm(
      charm?.geometry?.width?.value,
      charm?.geometry?.width?.unit
    );
  }

  function physicalCharmHeightMm(charm) {
    return unitToMm(
      charm?.geometry?.height?.value,
      charm?.geometry?.height?.unit
    );
  }

  function measurementSpan(measurement) {
    if (!measurement?.a || !measurement?.b) return 0;

    return Math.hypot(
      Number(measurement.b.x || 0) - Number(measurement.a.x || 0),
      Number(measurement.b.y || 0) - Number(measurement.a.y || 0)
    );
  }

  function chainPathNormalizedLength(base = state.base) {
    const path = sampleGeometryPath(base);
    if (path.length < 2) return 0;

    let total = 0;
    for (let i = 0; i < path.length - 1; i++) {
      total += pointDistance(path[i], path[i + 1]);
    }

    return total;
  }

  function medianNumber(values) {
    const cleanValues = values
      .filter(value => Number.isFinite(value) && value > 0)
      .sort((a, b) => a - b);

    if (!cleanValues.length) return 0;
    const middle = Math.floor(cleanValues.length / 2);

    return cleanValues.length % 2
      ? cleanValues[middle]
      : (cleanValues[middle - 1] + cleanValues[middle]) / 2;
  }

  function pixelsPerMm(base = state.base) {
    const canvasSize = Math.max(
      1,
      previewCanvas?.offsetWidth || previewCanvas?.clientWidth || 1
    );

    const chain = base?.geometry?.chain || {};

    /*
      V8 PRIMARY SCALE: merchant-verified individual-link rulers.
      ----------------------------------------------------------
      Product Configurator V14 stores a real line across the LONG side and a
      real line across the SHORT side of one physical link. This is the most
      local and reliable way to make a 1.5 cm charm look like 1.5 cm next to a
      2 cm x 1 cm link.
    */
    const explicitLinkScales = [];
    const explicitLongMm = physicalChainLinkWidthMm(base);
    const explicitShortMm = physicalChainLinkHeightMm(base);
    const explicitLongSpan = measurementSpan(chain?.linkWidth);
    const explicitShortSpan = measurementSpan(chain?.linkHeight);

    if (explicitLongMm > 0 && explicitLongSpan > 0) {
      explicitLinkScales.push(
        explicitLongSpan * canvasSize / explicitLongMm
      );
    }
    if (explicitShortMm > 0 && explicitShortSpan > 0) {
      explicitLinkScales.push(
        explicitShortSpan * canvasSize / explicitShortMm
      );
    }

    const explicitLinkScale = medianNumber(explicitLinkScales);
    if (explicitLinkScale > 0) return explicitLinkScale;

    /*
      SECONDARY SCALE: auto-detected individual-link footprint.
    */
    const linkLongMm = physicalChainLinkWidthMm(base);
    const linkShortMm = physicalChainLinkHeightMm(base);
    const linkLongRatio = Math.max(0, Number(chain?.detectedLinkLengthRatio || 0));
    const linkShortRatio = Math.max(0, Number(chain?.detectedLinkWidthRatio || 0));
    const linkScales = [];

    if (linkLongMm > 0 && linkLongRatio > 0) {
      linkScales.push(linkLongRatio * canvasSize / linkLongMm);
    }
    if (linkShortMm > 0 && linkShortRatio > 0) {
      linkScales.push(linkShortRatio * canvasSize / linkShortMm);
    }

    const linkScale = medianNumber(linkScales);
    if (linkScale > 0) return linkScale;

    /*
      TERTIARY SCALE: true laid-flat outer-edge rulers.
    */
    const rulerScales = [];
    const widthMm = unitToMm(chain?.width?.value, chain?.width?.unit);
    const heightMm = unitToMm(chain?.height?.value, chain?.height?.unit);
    const widthSpan = measurementSpan(chain?.width);
    const heightSpan = measurementSpan(chain?.height);

    if (widthMm > 0 && widthSpan > 0) {
      rulerScales.push(widthSpan * canvasSize / widthMm);
    }
    if (heightMm > 0 && heightSpan > 0) {
      rulerScales.push(heightSpan * canvasSize / heightMm);
    }

    const rulerScale = medianNumber(rulerScales);
    if (rulerScale > 0) return rulerScale;

    /*
      QUATERNARY SCALE: full physical path length.
    */
    const realLengthMm = physicalChainLengthMm(base);
    const normalizedLength = chainPathNormalizedLength(base);

    if (realLengthMm > 0 && normalizedLength > 0) {
      return normalizedLength * canvasSize / realLengthMm;
    }

    /*
      FINAL FALLBACK SCALE: center-to-center link pitch.
    */
    const centers = Array.isArray(chain?.linkCenters) ? chain.linkCenters : [];
    const linkPitchMm = unitToMm(chain?.linkPitch?.value, chain?.linkPitch?.unit);

    if (centers.length > 1 && linkPitchMm > 0) {
      const distances = [];
      for (let i = 1; i < centers.length; i++) {
        const a = centers[i - 1];
        const bb = centers[i];
        const d = Math.hypot(
          Number(bb?.x || 0) - Number(a?.x || 0),
          Number(bb?.y || 0) - Number(a?.y || 0)
        );
        if (d > 0) distances.push(d);
      }
      const medianDistance = medianNumber(distances);
      if (medianDistance > 0) {
        return medianDistance * canvasSize / linkPitchMm;
      }
    }

    return 0;
  }

  function charmDisplayMetrics(charm) {
    const ppm = pixelsPerMm();
    const widthMm = physicalCharmWidthMm(charm);
    const heightMm = physicalCharmHeightMm(charm);

    const widthSpan = measurementSpan(charm?.geometry?.width);
    const heightSpan = measurementSpan(charm?.geometry?.height);

    if (
      ppm > 0 &&
      widthMm > 0 &&
      heightMm > 0 &&
      widthSpan > 0 &&
      heightSpan > 0
    ) {
      return {
        widthPx: Math.max(8, widthMm * ppm / widthSpan),
        heightPx: Math.max(8, heightMm * ppm / heightSpan),
        physical: true
      };
    }

    const fallback = Math.max(
      24,
      parseFloat(
        getComputedStyle(section).getPropertyValue('--ltsb-charm-size')
      ) || 74
    );

    return {
      widthPx: fallback,
      heightPx: fallback,
      physical: false
    };
  }

  function primaryCharmConnector(charm) {
    const connectors = Array.isArray(charm?.geometry?.connectors)
      ? charm.geometry.connectors
      : [];

    const connector = connectors[0];

    if (
      connector &&
      Number.isFinite(Number(connector.x)) &&
      Number.isFinite(Number(connector.y))
    ) {
      return {
        x: clamp01(connector.x),
        y: clamp01(connector.y)
      };
    }

    const configuredY = parseFloat(
      getComputedStyle(section).getPropertyValue('--ltsb-charm-y')
    );

    return {
      x: .5,
      y: Number.isFinite(configuredY)
        ? Math.max(0, Math.min(1, configuredY / 100))
        : .14
    };
  }

  function circularPathDistanceMm(a, b, base = state.base) {
    const path = sampleGeometryPath(base, 36);
    const ppm = pixelsPerMm(base);
    const canvasSize = Math.max(
      1,
      previewCanvas?.offsetWidth || previewCanvas?.clientWidth || 1
    );

    /*
      Use the SAME local scale that sizes the charms. This keeps the configured
      0.2 cm gap visually and physically consistent even when overlapping chain
      links make "total chain length / number of links" a poor estimate of
      center-to-center spacing.
    */
    if (path.length > 1 && ppm > 0) {
      const cumulative = [0];
      for (let i = 1; i < path.length; i++) {
        cumulative[i] =
          cumulative[i - 1] +
          pointDistance(path[i - 1], path[i]);
      }

      const total = cumulative[cumulative.length - 1] || 0;
      if (total > 0) {
        const indexForT = value =>
          Math.max(
            0,
            Math.min(
              path.length - 1,
              Math.round(clamp01(value) * (path.length - 1))
            )
          );

        const da = cumulative[indexForT(a)];
        const db = cumulative[indexForT(b)];
        let normalizedDistance = Math.abs(db - da);

        if (base?.geometry?.chain?.closed) {
          normalizedDistance = Math.min(
            normalizedDistance,
            Math.max(0, total - normalizedDistance)
          );
        }

        return normalizedDistance * canvasSize / ppm;
      }
    }

    /* Backward-compatible fallback for old geometry without visual calibration. */
    const lengthMm = physicalChainLengthMm(base);
    if (!(lengthMm > 0)) return Infinity;

    const delta = Math.abs(clamp01(a) - clamp01(b));
    const closed = Boolean(base?.geometry?.chain?.closed);
    const normalized = closed ? Math.min(delta, 1 - delta) : delta;

    return normalized * lengthMm;
  }

  function minimumCharmGapMm(base = state.base) {
    return unitToMm(
      base?.geometry?.chain?.minCharmGap?.value,
      base?.geometry?.chain?.minCharmGap?.unit
    );
  }

  function allowedCharmOverlapMm(base = state.base) {
    const configured = unitToMm(
      base?.geometry?.chain?.allowedCharmOverlap?.value,
      base?.geometry?.chain?.allowedCharmOverlap?.unit
    );

    /*
      Slight physical overlap is normal with hanging charms. Older products
      do not have this field yet, so use a conservative 2.5 mm default.
    */
    return configured > 0 ? configured : 2.5;
  }

  function placementPathT(placement, anchorIndex) {
    if (
      placement &&
      Number.isFinite(Number(placement.pathT))
    ) {
      return clamp01(placement.pathT);
    }

    const point = anchorLayout()[anchorIndex];
    return Number.isFinite(Number(point?.pathT))
      ? clamp01(point.pathT)
      : null;
  }

  /*
    Physical charm-body collision
    -----------------------------
    The old spacing rule compared charm WIDTHS along the chain path. That was
    too conservative on a curved bracelet because two charms can hang outward
    from adjacent links without their actual bodies touching.

    We now compare the real configured charm bodies after connector placement
    and automatic outward rotation. minCharmGap is now a preferred visual
    spacing target; slight body overlap is allowed up to allowedCharmOverlap.
  */
  function charmBodyPolygonPx(charm, pathT) {
    const point = pathPointAtT(pathT);
    if (!point || !previewCanvas) return null;

    const metrics = charmDisplayMetrics(charm);
    if (!(metrics.widthPx > 0) || !(metrics.heightPx > 0)) return null;

    const connector = primaryCharmConnector(charm);
    const width = charm?.geometry?.width;
    const height = charm?.geometry?.height;

    const wx = [width?.a?.x, width?.b?.x].map(Number).filter(Number.isFinite);
    const hy = [height?.a?.y, height?.b?.y].map(Number).filter(Number.isFinite);

    let left = wx.length === 2 ? Math.min(...wx) : 0;
    let right = wx.length === 2 ? Math.max(...wx) : 1;
    let top = hy.length === 2 ? Math.min(...hy) : 0;
    let bottom = hy.length === 2 ? Math.max(...hy) : 1;

    if (!(right - left > .001)) { left = 0; right = 1; }
    if (!(bottom - top > .001)) { top = 0; bottom = 1; }

    const size = Math.max(
      1,
      previewCanvas.offsetWidth || previewCanvas.clientWidth || 1
    );
    const originX = point.x * size;
    const originY = point.y * size;
    const angle = outwardCharmRotation(pathT, charm) * Math.PI / 180;
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);

    return [
      [left, top], [right, top], [right, bottom], [left, bottom]
    ].map(([x, y]) => {
      const dx = (x - connector.x) * metrics.widthPx;
      const dy = (y - connector.y) * metrics.heightPx;
      return {
        x: originX + dx * cos - dy * sin,
        y: originY + dx * sin + dy * cos
      };
    });
  }

  function polygonsOverlap(a, b) {
    const axes = [];
    [a, b].forEach(poly => {
      for (let i = 0; i < poly.length; i++) {
        const p = poly[i];
        const q = poly[(i + 1) % poly.length];
        const dx = q.x - p.x;
        const dy = q.y - p.y;
        const len = Math.hypot(dx, dy) || 1;
        axes.push({ x: -dy / len, y: dx / len });
      }
    });

    return axes.every(axis => {
      const project = poly => poly.map(p => p.x * axis.x + p.y * axis.y);
      const pa = project(a);
      const pb = project(b);
      return Math.max(...pa) >= Math.min(...pb) &&
             Math.max(...pb) >= Math.min(...pa);
    });
  }

  function polygonPenetrationPx(a, b) {
    const axes = [];

    [a, b].forEach(poly => {
      for (let i = 0; i < poly.length; i++) {
        const p = poly[i];
        const q = poly[(i + 1) % poly.length];
        const dx = q.x - p.x;
        const dy = q.y - p.y;
        const len = Math.hypot(dx, dy) || 1;
        axes.push({ x: -dy / len, y: dx / len });
      }
    });

    let minimumPenetration = Infinity;

    for (const axis of axes) {
      const project = poly => poly.map(p => p.x * axis.x + p.y * axis.y);
      const pa = project(a);
      const pb = project(b);
      const minA = Math.min(...pa);
      const maxA = Math.max(...pa);
      const minB = Math.min(...pb);
      const maxB = Math.max(...pb);
      const overlap = Math.min(maxA, maxB) - Math.max(minA, minB);

      if (overlap <= 0) return 0;
      minimumPenetration = Math.min(minimumPenetration, overlap);
    }

    return Number.isFinite(minimumPenetration)
      ? Math.max(0, minimumPenetration)
      : 0;
  }

  function polygonApproxMinDimensionPx(poly) {
    if (!Array.isArray(poly) || poly.length < 4) return 0;

    const lengths = [];
    for (let i = 0; i < poly.length; i++) {
      const a = poly[i];
      const b = poly[(i + 1) % poly.length];
      lengths.push(Math.hypot(b.x - a.x, b.y - a.y));
    }

    return lengths.length ? Math.min(...lengths) : 0;
  }

  function pointSegmentDistancePx(p, a, b) {
    const vx = b.x - a.x;
    const vy = b.y - a.y;
    const length2 = vx * vx + vy * vy;
    if (!(length2 > 0)) return Math.hypot(p.x - a.x, p.y - a.y);

    const t = Math.max(
      0,
      Math.min(1, ((p.x - a.x) * vx + (p.y - a.y) * vy) / length2)
    );
    return Math.hypot(
      p.x - (a.x + vx * t),
      p.y - (a.y + vy * t)
    );
  }

  function polygonGapPx(a, b) {
    if (polygonsOverlap(a, b)) return 0;

    let best = Infinity;
    const test = (points, edges) => {
      points.forEach(point => {
        for (let i = 0; i < edges.length; i++) {
          best = Math.min(
            best,
            pointSegmentDistancePx(
              point,
              edges[i],
              edges[(i + 1) % edges.length]
            )
          );
        }
      });
    };

    test(a, b);
    test(b, a);
    return best;
  }

  function legacyPathSpacingFitsAt(productId, pathT, ignoreIndex = -1) {
    const charm = charms.get(String(productId));
    const candidateWidth = physicalCharmWidthMm(charm);
    const minGap = minimumCharmGapMm();
    if (!(candidateWidth > 0) || !(physicalChainLengthMm() > 0)) return true;

    for (let index = 0; index < state.placements.length; index++) {
      if (index === ignoreIndex) continue;
      const placement = state.placements[index];
      if (!placement) continue;

      const otherCharm = charms.get(String(placement.productId));
      const otherWidth = physicalCharmWidthMm(otherCharm);
      const otherT = placementPathT(placement, index);
      if (!(otherWidth > 0) || otherT === null) continue;

      const overlapAllowance = allowedCharmOverlapMm();

      if (
        circularPathDistanceMm(pathT, otherT) <
        candidateWidth / 2 + otherWidth / 2 - overlapAllowance
      ) return false;
    }
    return true;
  }

  function placementFitsAt(productId, pathT, ignoreIndex = -1) {
    const charm = charms.get(String(productId));
    if (!charm || !pathTIsLegal(pathT)) return false;

    const chain = state.base?.geometry?.chain;
    if (chain?.forceSpacingOverride) return true;

    const ppm = pixelsPerMm();
    const candidateBody = charmBodyPolygonPx(charm, pathT);

    /* Old products without enough calibration keep the previous safe behavior. */
    if (!(ppm > 0) || !candidateBody) {
      return legacyPathSpacingFitsAt(productId, pathT, ignoreIndex);
    }

    const configuredOverlapPx = Math.max(0, allowedCharmOverlapMm()) * ppm;

    for (let index = 0; index < state.placements.length; index++) {
      if (index === ignoreIndex) continue;
      const placement = state.placements[index];
      if (!placement) continue;

      const otherCharm = charms.get(String(placement.productId));
      const otherT = placementPathT(placement, index);
      if (!otherCharm || otherT === null) continue;

      const otherBody = charmBodyPolygonPx(otherCharm, otherT);
      if (!otherBody) {
        if (!legacyPathSpacingFitsAt(productId, pathT, ignoreIndex)) return false;
        continue;
      }

      if (!polygonsOverlap(candidateBody, otherBody)) {
        /*
          A positive visible gap is always physically acceptable. The configured
          minCharmGap is now a SOFT auto-placement preference, not a hard wall.
        */
        continue;
      }

      const penetrationPx = polygonPenetrationPx(candidateBody, otherBody);

      /*
        Never let "slight overlap" swallow a tiny charm. The hard allowance is
        whichever is smaller:
          - configured overlap allowance
          - 35% of the smaller charm body's narrow dimension
      */
      const bodySafetyCapPx =
        Math.min(
          polygonApproxMinDimensionPx(candidateBody),
          polygonApproxMinDimensionPx(otherBody)
        ) * 0.35;

      const allowedPx = Math.min(configuredOverlapPx, bodySafetyCapPx);

      /* 0.35px tolerance prevents sub-pixel rounding from blocking a fit. */
      if (penetrationPx > allowedPx + .35) {
        return false;
      }
    }

    return true;
  }

  function placementMeetsPreferredGapAt(productId, pathT, ignoreIndex = -1) {
    const preferredGapMm = Math.max(0, minimumCharmGapMm());
    if (!(preferredGapMm > 0)) return true;

    const charm = charms.get(String(productId));
    const ppm = pixelsPerMm();
    const candidateBody = charmBodyPolygonPx(charm, pathT);

    if (!(ppm > 0) || !candidateBody) return true;

    const preferredGapPx = preferredGapMm * ppm;

    for (let index = 0; index < state.placements.length; index++) {
      if (index === ignoreIndex) continue;
      const placement = state.placements[index];
      if (!placement) continue;

      const otherCharm = charms.get(String(placement.productId));
      const otherT = placementPathT(placement, index);
      if (!otherCharm || otherT === null) continue;

      const otherBody = charmBodyPolygonPx(otherCharm, otherT);
      if (!otherBody) continue;

      if (polygonsOverlap(candidateBody, otherBody)) return false;
      if (polygonGapPx(candidateBody, otherBody) + .35 < preferredGapPx) {
        return false;
      }
    }

    return true;
  }

  function safeAnchorIndexForCharm(productId, preferredIndex = -1) {
    const layout = anchorLayout();
    if (!layout.length) return -1;

    const order = [];

    if (preferredIndex >= 0 && preferredIndex < layout.length) {
      order.push(preferredIndex);
    }

    for (let i = 0; i < layout.length; i++) {
      if (!order.includes(i)) order.push(i);
    }

    /*
      Adjacent physical links are valid placement choices. Do NOT skip a link
      merely because the configured visual-gap target is not met. The only
      hard body-spacing rule is the allowed-overlap tolerance in
      placementFitsAt().
    */
    for (const index of order) {
      if (state.placements[index]) continue;

      const pathT = Number(layout[index]?.pathT);
      if (
        Number.isFinite(pathT) &&
        pathTIsLegal(pathT) &&
        placementFitsAt(productId, pathT)
      ) {
        return index;
      }

      // Legacy fallback when a chain has not yet been configured in the app.
      if (!Number.isFinite(pathT) && !state.base?.geometry?.chain?.path?.length) {
        return index;
      }
    }

    return -1;
  }

  function nearestRawPathPosition(clientX, clientY) {
    const path = sampleGeometryPath();
    if (!path.length || !previewCanvas) return null;

    const rect = previewCanvas.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;

    const nx = (clientX - rect.left) / rect.width;
    const ny = (clientY - rect.top) / rect.height;

    let best = null;
    let bestDistance = Infinity;

    for (let index = 0; index < path.length; index++) {
      const point = path[index];
      const distance = Math.hypot(point.x - nx, point.y - ny);

      if (distance < bestDistance) {
        bestDistance = distance;
        best = {
          x: point.x,
          y: point.y,
          pathT: path.length <= 1 ? 0 : index / (path.length - 1),
          distance
        };
      }
    }

    return best;
  }

  function circularPathTFractionDistance(a, b, base = state.base) {
    const delta = Math.abs(clamp01(a) - clamp01(b));
    return base?.geometry?.chain?.closed
      ? Math.min(delta, 1 - delta)
      : delta;
  }

  function nearestEligibleSlotForPathT(
    pathT,
    productId,
    ignoreIndex = -1
  ) {
    const layout = anchorLayout();
    let best = null;
    let bestDistance = Infinity;

    layout.forEach((slot, index) => {
      if (index !== ignoreIndex && state.placements[index]) return;

      const slotT = Number(slot?.pathT);
      if (!Number.isFinite(slotT)) return;
      if (!pathTIsLegal(slotT)) return;
      if (!placementFitsAt(productId, slotT, ignoreIndex)) return;

      const distance = circularPathTFractionDistance(pathT, slotT);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = {
          x: Number(slot.x) / 100,
          y: Number(slot.y) / 100,
          pathT: clamp01(slotT),
          anchorIndex: index
        };
      }
    });

    return best;
  }

  function nearestLegalPathPosition(clientX, clientY, productId, ignoreIndex = -1) {
    /*
      Customer can RELEASE anywhere over the preview, but the physical
      attachment is always snapped to the center of a REAL link.

      Step 1: project the pointer to the smooth chain.
      Step 2: reject it immediately when that projected point is in:
              - clasp/hardware no-charm zone
              - generated link-to-link joint no-charm zone
              - outside a necklace's allowed charm area
      Step 3: snap to the nearest empty legal physical link center.
    */
    const raw = nearestRawPathPosition(clientX, clientY);
    if (!raw) return null;
    if (!pathTIsLegal(raw.pathT)) return null;

    return nearestEligibleSlotForPathT(
      raw.pathT,
      productId,
      ignoreIndex
    );
  }

  function pointIsInsidePreview(clientX, clientY, padding = 14) {
    if (!preview) return false;
    const rect = preview.getBoundingClientRect();
    return (
      clientX >= rect.left - padding &&
      clientX <= rect.right + padding &&
      clientY >= rect.top - padding &&
      clientY <= rect.bottom + padding
    );
  }

  function showFreeDropPreview(productId, targetPosition) {
    clearDropPreview();
    if (!targetPosition) return;

    const charm = charms.get(String(productId));
    if (!charm) return;

    const previewEl = document.createElement('div');
    previewEl.className = 'ltsb__drop-preview';
    previewEl.dataset.dropPreview = 'true';
    previewEl.style.setProperty('--x', `${targetPosition.x * 100}%`);
    previewEl.style.setProperty('--y', `${targetPosition.y * 100}%`);

    const metrics = charmDisplayMetrics(charm);
    const connector = primaryCharmConnector(charm);
    const rotation = outwardCharmRotation(targetPosition.pathT, charm);

    previewEl.style.width = `${metrics.widthPx}px`;
    previewEl.style.height = `${metrics.heightPx}px`;
    previewEl.style.transformOrigin =
      `${connector.x * 100}% ${connector.y * 100}%`;
    previewEl.style.transform =
      `translate(${-connector.x * 100}%, ${-connector.y * 100}%) rotate(${rotation}deg)`;

    if (charm.image) {
      previewEl.innerHTML = `<img src="${escapeHtml(charm.image)}" alt="">`;
    }

    anchorLayer.appendChild(previewEl);
  }

  /*
    If no manual lt_anchor_layout exists, make a sensible default.
    Bracelet = ellipse around the chain.
    Necklace = U-shaped arrangement.
  */
  function generatedLayout(base) {
    const count = Math.max(0, Number(base && base.anchorCount || 0));
    if (!count) return [];

    if (base.type === 'necklace') {
      const points = [];

      for (let i = 0; i < count; i++) {
        const t = count === 1 ? .5 : i / (count - 1);
        const x = 18 + t * 64;
        const centered = (t - .5) * 2;
        const y = 34 + (1 - Math.pow(centered, 2)) * 30;

        points.push({
          x: Number(x.toFixed(2)),
          y: Number(y.toFixed(2))
        });
      }

      return points;
    }

    const points = [];
    const start = 205;
    const end = 335;

    for (let i = 0; i < count; i++) {
      const t = count === 1 ? .5 : i / (count - 1);
      const angle = (start + (end - start) * t) * Math.PI / 180;

      points.push({
        x: Number((50 + Math.cos(angle) * 33).toFixed(2)),
        y: Number((46 + Math.sin(angle) * 31).toFixed(2))
      });
    }

    return points;
  }

  function savedOrGeneratedLayout() {
    if (!state.base) return [];

    /*
      V8 storefront placement grid = physical link centers.
      ----------------------------------------------------
      defaultAnchors remain useful in the configurator as suggested positions,
      but customers are not limited to that subset. Every detected physical
      link center that is legal becomes a possible attachment slot.

      This is what lets a bracelet use all the room it actually has while still
      preventing placement on link-to-link joints.
    */
    const geometryLinkCenters = Array.isArray(
      state.base.geometry?.chain?.linkCenters
    )
      ? state.base.geometry.chain.linkCenters
          .map((point, index) => ({
            x: Number(point?.x) * 100,
            y: Number(point?.y) * 100,
            pathT: Number(point?.pathT),
            linkIndex: Number.isFinite(Number(point?.linkIndex))
              ? Number(point.linkIndex)
              : index,
            inferred: Boolean(point?.inferred)
          }))
          .filter(point =>
            Number.isFinite(point.x) &&
            Number.isFinite(point.y) &&
            Number.isFinite(point.pathT) &&
            pathTIsLegal(point.pathT)
          )
          .sort((a, b) => a.pathT - b.pathT)
      : [];

    if (geometryLinkCenters.length) {
      return geometryLinkCenters;
    }

    /*
      Older configured products can still fall back to saved default anchors.
    */
    const geometryAnchors = Array.isArray(
      state.base.geometry?.chain?.defaultAnchors
    )
      ? state.base.geometry.chain.defaultAnchors
          .map(point => ({
            x: Number(point?.x) * 100,
            y: Number(point?.y) * 100,
            pathT: Number(point?.pathT),
            linkIndex: Number.isFinite(Number(point?.linkIndex))
              ? Number(point.linkIndex)
              : null
          }))
          .filter(point =>
            Number.isFinite(point.x) &&
            Number.isFinite(point.y) &&
            Number.isFinite(point.pathT) &&
            pathTIsLegal(point.pathT)
          )
      : [];

    if (geometryAnchors.length) return geometryAnchors;

    const manual = Array.isArray(state.base.layout)
      ? state.base.layout
          .map(point => ({
            x: Number(point && point.x),
            y: Number(point && point.y)
          }))
          .filter(point =>
            Number.isFinite(point.x) &&
            Number.isFinite(point.y)
          )
      : [];

    if (manual.length) return manual;

    return generatedLayout(state.base);
  }

  function anchorLayout() {
    if (!state.base) return [];

    const draft = state.anchorDrafts[String(state.base.productId)];

    if (Array.isArray(draft) && draft.length) {
      return draft.map(point => ({ ...point, x: Number(point.x), y: Number(point.y) }));
    }

    return savedOrGeneratedLayout();
  }

  function ensureAnchorDraft() {
    if (!state.base) return [];

    const key = String(state.base.productId);

    if (!Array.isArray(state.anchorDrafts[key])) {
      state.anchorDrafts[key] = savedOrGeneratedLayout().map(point => ({
        ...point,
        x: Number(point.x),
        y: Number(point.y)
      }));
    }

    return state.anchorDrafts[key];
  }

  function syncAnchorEditor() {
    if (!anchorSetupMode) return;

    const textarea = $('[data-anchor-json]');
    const product = $('[data-anchor-editor-product]');

    if (!textarea || !product) return;

    if (!state.base) {
      product.textContent = 'Choose a chain';
      textarea.value = '';
      return;
    }

    product.textContent = state.base.title;

    const layout = anchorLayout().map(point => ({
      x: Number(Number(point.x).toFixed(2)),
      y: Number(Number(point.y).toFixed(2))
    }));

    textarea.value = JSON.stringify(layout);
  }

  function maxAnchors() {
    return anchorLayout().length;
  }

  function designCharmLimit() {
    const physicalSlots = maxAnchors();
    const manual = Math.floor(
      Number(state.base?.geometry?.chain?.manualMaxCharms || 0)
    );

    return manual > 0
      ? Math.min(physicalSlots, manual)
      : physicalSlots;
  }

  function baseStorageKey(base = state.base) {
    if (!base) return '';
    return String(base.variantId || base.productId || '');
  }

  function readSavedBuilderState() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || parsed.version !== STORAGE_VERSION) return null;

      /*
        The merchant's assembly default is configuration, not customer data.

        If the merchant changes that setting (for example from "assembled"
        to "none"), do not let a previously persisted customer selection keep
        one of the buttons highlighted after refresh. Clear ONLY the saved
        assembly choice while preserving the selected chain, charm count and
        placements.

        Older saved payloads did not include assemblyDefault. Treat those as
        stale once so this fix also cleans up choices stored before deployment.
      */
      const savedAssemblyDefault = String(
        parsed.assemblyDefault || ''
      ).toLowerCase();

      const assemblyDefaultChanged =
        !savedAssemblyDefault ||
        savedAssemblyDefault !== configuredAssemblyDefault;

      if (assemblyDefaultChanged) {
        if (parsed.designs && typeof parsed.designs === 'object') {
          Object.values(parsed.designs).forEach(design => {
            if (!design || typeof design !== 'object') return;

            design.assembly = defaultAssemblyState();
            design.assemblyExplicit = false;
          });
        }

        parsed.assemblyDefault = configuredAssemblyDefault;

        /* Persist the migrated payload immediately so the reset happens once. */
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(parsed)
        );
      }

      return parsed;
    } catch (error) {
      console.warn('[Little Things] Could not read saved builder design:', error);
      return null;
    }
  }

  function persistBuilderState() {
    try {
      const payload = {
        version: STORAGE_VERSION,
        activeVariantId: state.base ? String(state.base.variantId) : null,
        type: state.type,
        style: state.style,
        assemblyDefault: configuredAssemblyDefault,
        designs: state.designs
      };

      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(payload)
      );
    } catch (error) {
      console.warn('[Little Things] Could not save builder design:', error);
    }
  }

  function saveCurrentDesign({ persist = true } = {}) {
    if (!state.base) {
      if (persist) persistBuilderState();
      return;
    }

    const key = baseStorageKey();
    if (!key) return;

    state.designs[key] = {
      targetCount: state.targetCount,
      assembly:
        state.assembly === null
          ? null
          : Boolean(state.assembly),
      assemblyExplicit: Boolean(state.assemblyExplicit),
      placements: state.placements.map(placement =>
        placement
          ? {
              productId: String(placement.productId),
              pathT: Number.isFinite(Number(placement.pathT))
                ? Number(placement.pathT)
                : null
            }
          : null
      )
    };

    if (persist) persistBuilderState();
  }

  function restoreDesignForBase(base, { persist = true } = {}) {
    if (!base) {
      state.base = null;
      state.placements = [];
      state.targetCount = null;
      state.assembly = defaultAssemblyState();
      state.assemblyExplicit = false;
      if (persist) persistBuilderState();
      return;
    }

    state.base = base;

    const max = maxAnchors();
    const key = baseStorageKey(base);
    const saved = key ? state.designs[key] : null;

    const placements = new Array(max).fill(null);

    if (saved && Array.isArray(saved.placements)) {
      saved.placements.slice(0, max).forEach((savedPlacement, index) => {
        const id = String(
          savedPlacement && typeof savedPlacement === 'object'
            ? savedPlacement.productId || ''
            : savedPlacement || ''
        ).trim();

        /*
          Ignore deleted/unavailable charm IDs instead of breaking restoration.
        */
        if (!id || !charms.has(id)) return;

        const savedPathT =
          savedPlacement && typeof savedPlacement === 'object'
            ? Number(savedPlacement.pathT)
            : NaN;

        placements[index] = {
          instanceId: `lt-restored-${Date.now()}-${++instanceCounter}`,
          productId: id,
          pathT: Number.isFinite(savedPathT)
            ? clamp01(savedPathT)
            : Number.isFinite(Number(anchorLayout()[index]?.pathT))
              ? clamp01(anchorLayout()[index].pathT)
              : null
        };
      });
    }

    state.placements = placements;

    /*
      Assembly persistence rules:

      - "assembled" default: restore an explicit customer choice for this chain.
      - "loose" default: restore an explicit customer choice for this chain.
      - "none" default: NEVER restore an assembly choice after a page refresh.

      "No default" means the merchant wants every fresh page load to require a
      deliberate choice. We still preserve the selected chain, charm count and
      charm placements; only the assembly decision is cleared on hydration.
    */
    const savedAssemblyIsExplicit = Boolean(
      saved && saved.assemblyExplicit === true
    );

    if (configuredAssemblyDefault === 'none') {
      state.assembly = null;
      state.assemblyExplicit = false;
    } else if (savedAssemblyIsExplicit) {
      state.assembly =
        saved.assembly === true
          ? Boolean(assemblyService.available)
          : false;
      state.assemblyExplicit = true;
    } else {
      state.assembly = defaultAssemblyState();
      state.assemblyExplicit = false;
    }

    const selected = selectedCount();

    if (!max) {
      state.targetCount = null;
    } else {
      const requested = Number(saved && saved.targetCount);
      const normalizedRequested =
        Number.isFinite(requested) && requested >= 1
          ? Math.min(max, requested)
          : 1;

      /*
        Never restore a slider lower than the number of charms that actually
        exist on this particular chain.
      */
      state.targetCount = Math.max(selected || 1, normalizedRequested);
    }

    if (persist) {
      saveCurrentDesign();
    }
  }

  function resetPlacements() {
    /*
      Kept as an internal helper for a truly fresh chain.
      It does NOT affect saved designs for other chains.
    */
    state.placements = new Array(maxAnchors()).fill(null);
    state.targetCount = maxAnchors() ? 1 : null;
  }

  function hydrateSavedBuilderState() {
    const saved = readSavedBuilderState();
    if (!saved) return false;

    if (saved.designs && typeof saved.designs === 'object') {
      state.designs = saved.designs;
    }

    const activeVariantId = String(saved.activeVariantId || '');
    const activeBase = bases.find(base =>
      String(base.variantId) === activeVariantId
    );

    if (activeBase) {
      state.type = activeBase.type;
      state.style = activeBase.style;
      restoreDesignForBase(activeBase, { persist: false });
      return true;
    }

    if (saved.type === 'bracelet' || saved.type === 'necklace') {
      state.type = saved.type;
    }

    if (saved.style) {
      state.style = saved.style;
    }

    return false;
  }

  function firstEmptyAnchor() {
    return state.placements.findIndex(item => !item);
  }

  function clearDropPreview() {
    const existing = $('[data-drop-preview]', anchorLayer);
    if (existing) existing.remove();
  }

  function showDropPreview(productId, anchorIndex) {
    clearDropPreview();
    if (anchorIndex < 0) return;

    const charm = charms.get(String(productId));
    const point = anchorLayout()[anchorIndex];
    if (!charm || !point) return;

    const previewEl = document.createElement('div');
    previewEl.className = 'ltsb__drop-preview';
    previewEl.dataset.dropPreview = 'true';
    previewEl.style.setProperty('--x', `${point.x}%`);
    previewEl.style.setProperty('--y', `${point.y}%`);
    previewEl.innerHTML = charm.image
      ? `<img src="${escapeHtml(charm.image)}" alt="">`
      : '';

    anchorLayer.appendChild(previewEl);
  }

  function animatePlacement(anchorIndex, flashAnchor = true) {
    requestAnimationFrame(() => {
      const placed = $(`.ltsb__placed[data-anchor-index="${anchorIndex}"]`, anchorLayer);
      const anchor = $(`.ltsb__anchor[data-anchor-index="${anchorIndex}"]`, anchorLayer);

      if (placed) {
        placed.classList.remove('is-dropping');
        void placed.offsetWidth;
        placed.classList.add('is-dropping');
        window.setTimeout(() => placed.classList.remove('is-dropping'), 430);
      }

      if (flashAnchor && anchor) {
        anchor.classList.remove('is-drop-success');
        void anchor.offsetWidth;
        anchor.classList.add('is-drop-success');
        window.setTimeout(() => anchor.classList.remove('is-drop-success'), 490);
      }
    });
  }

  function placeCharm(productId, anchorIndex) {
    if (!state.base) {
      setMessage('Choose your bracelet or necklace first.', true);
      return false;
    }

    const max = designCharmLimit();

    if (!max) {
      setMessage('This piece isn’t ready for charms yet.', true);
      return false;
    }

    if (selectedCount() >= max) {
      setMessage('Every charm spot is already filled.', true);
      return false;
    }

    const safeIndex = safeAnchorIndexForCharm(productId, anchorIndex);

    if (safeIndex < 0) {
      setMessage(
        'There is no safe space left for that charm on this chain. Try a smaller charm or move another charm farther away.',
        true
      );
      return false;
    }

    anchorIndex = safeIndex;

    if (state.placements[anchorIndex]) {
      setMessage('That spot already has a charm. Choose another.', true);
      return false;
    }

    const anchor = anchorLayout()[anchorIndex];

    state.placements[anchorIndex] = {
      instanceId: `lt-${Date.now()}-${++instanceCounter}`,
      productId: String(productId),
      pathT: Number.isFinite(Number(anchor?.pathT))
        ? clamp01(anchor.pathT)
        : null
    };

    /* The slider is a planning aid, not a hard wall.
       If the customer adds beyond the number they originally chose,
       automatically grow it to match the actual design. */
    const nowSelected = selectedCount();
    if (!state.targetCount || nowSelected > state.targetCount) {
      state.targetCount = nowSelected;
      if (countRange) countRange.value = String(nowSelected);
    }

    saveCurrentDesign();
    setMessage('');
    renderPreview();
    updateUI();
    animatePlacement(anchorIndex);
    return true;
  }

  function placeCharmAtPath(productId, pathT, preferredStorageIndex = -1) {
    const charm = charms.get(String(productId));
    if (!charm || !state.base || !charm.available) return false;

    if (selectedCount() >= designCharmLimit()) {
      setMessage('You have reached the safe charm capacity for this piece.', true);
      return false;
    }

    const requestedT = clamp01(pathT);

    if (!pathTIsLegal(requestedT)) {
      setMessage(
        'That spot is a no-charm area. Drop inside the center of a usable link.',
        true
      );
      return false;
    }

    /*
      Free drag/drop never stores an arbitrary smooth-path coordinate anymore.
      It resolves to a real, empty, legal link center.
    */
    let target = null;

    if (
      preferredStorageIndex >= 0 &&
      preferredStorageIndex < anchorLayout().length &&
      !state.placements[preferredStorageIndex]
    ) {
      const preferred = anchorLayout()[preferredStorageIndex];
      const preferredT = Number(preferred?.pathT);

      if (
        Number.isFinite(preferredT) &&
        pathTIsLegal(preferredT) &&
        placementFitsAt(productId, preferredT)
      ) {
        target = {
          anchorIndex: preferredStorageIndex,
          pathT: clamp01(preferredT)
        };
      }
    }

    if (!target) {
      target = nearestEligibleSlotForPathT(
        requestedT,
        productId
      );
    }

    if (!target) {
      setMessage(
        'That link would overlap the neighboring charm more than the allowed overlap. Try another link.',
        true
      );
      return false;
    }

    const storageIndex = target.anchorIndex;

    state.placements[storageIndex] = {
      instanceId: `lt-${Date.now()}-${++instanceCounter}`,
      productId: String(productId),
      pathT: target.pathT
    };

    state.targetCount = Math.max(
      Number(state.targetCount || 1),
      selectedCount()
    );

    saveCurrentDesign();
    setMessage('');
    renderPreview();
    updateUI();
    animatePlacement(storageIndex, false);
    return true;
  }

  function removePlacement(anchorIndex) {
    if (!state.placements[anchorIndex]) return;

    state.placements[anchorIndex] = null;
    saveCurrentDesign();
    setMessage('');
    renderPreview();
    updateUI();
  }

  function movePlacement(fromIndex, toIndex) {
    if (
      fromIndex === toIndex ||
      fromIndex < 0 ||
      toIndex < 0 ||
      fromIndex >= state.placements.length ||
      toIndex >= state.placements.length
    ) {
      return;
    }

    const source = state.placements[fromIndex];
    if (!source) return;

    const destination = state.placements[toIndex];

    /*
      Drop on occupied anchor = swap.
      Drop on empty anchor = move.
    */
    const targetAnchor = anchorLayout()[toIndex];
    const sourceAnchor = anchorLayout()[fromIndex];

    state.placements[toIndex] = {
      ...source,
      pathT: Number.isFinite(Number(targetAnchor?.pathT))
        ? clamp01(targetAnchor.pathT)
        : source.pathT ?? null
    };

    state.placements[fromIndex] = destination
      ? {
          ...destination,
          pathT: Number.isFinite(Number(sourceAnchor?.pathT))
            ? clamp01(sourceAnchor.pathT)
            : destination.pathT ?? null
        }
      : null;

    saveCurrentDesign();
    renderPreview();
    updateUI();
    setMessage('');
    animatePlacement(toIndex);
    if (destination) animatePlacement(fromIndex, false);
  }

  function renderStyles() {
    const list = $('[data-style-list]');
    if (!list) return;

    const styles = uniqueStyles(state.type);
    list.innerHTML = '';

    if (!styles.length) {
      state.style = null;
      state.base = null;

      list.innerHTML =
        '<div class="ltsb__empty">No available chains found for this type.</div>';

      renderColors();
      renderPreview();
      updateUI();
      return;
    }

    if (
      !state.style ||
      !styles.some(item => item.name === state.style)
    ) {
      state.style = styles[0].name;
    }

    styles.forEach(({ name, sample }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className =
        'ltsb__style' +
        (name === state.style ? ' is-active' : '');

      const styleBases = bases.filter(base =>
        base.type === state.type &&
        base.style === name &&
        base.available
      );

      const prices = styleBases
        .map(base => Number(base.price || 0))
        .filter(price => Number.isFinite(price) && price >= 0);

      const minPrice = prices.length ? Math.min(...prices) : Number(sample.price || 0);
      const maxPrice = prices.length ? Math.max(...prices) : minPrice;

      button.innerHTML = `
        <span class="ltsb__style-image">
          ${
            sample.image
              ? `<img src="${sample.image}" alt="" loading="lazy">`
              : ''
          }
        </span>
        <strong></strong>
        <small class="ltsb__style-price"></small>
      `;

      $('strong', button).textContent = name;

      const price = $('.ltsb__style-price', button);
      if (price) {
        price.textContent =
          minPrice === maxPrice
            ? money(minPrice)
            : `From ${money(minPrice)}`;
      }

      button.addEventListener('click', () => {
        if (state.style === name) return;

        /*
          Save the chain we're leaving before selecting another style.
        */
        saveCurrentDesign();

        state.style = name;
        state.base = null;
        state.placements = [];
        state.targetCount = null;

        renderStyles();
        renderPreview();
        updateUI();
      });

      list.appendChild(button);
    });

    list.dispatchEvent(new Event('scroll'));
    renderColors();
  }

  function renderColors() {
    const list = $('[data-color-list]');
    if (!list) return;

    const options = basesForCurrentStyle();
    list.innerHTML = '';

    if (!options.length) {
      state.base = null;
      $('[data-size]').textContent = 'Choose a chain';

      renderRange();
      renderPreview();
      updateUI();
      return;
    }

    if (
      !state.base ||
      !options.some(option =>
        option.variantId === state.base.variantId
      )
    ) {
      restoreDesignForBase(options[0]);
    }

    options.forEach(base => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className =
        'ltsb__color' +
        (
          state.base &&
          base.variantId === state.base.variantId
            ? ' is-active'
            : ''
        );

      button.innerHTML = `
        <span
          class="ltsb__swatch"
          style="--swatch:${swatch(base.color, base.swatchColor)}"
        ></span>
        <span></span>
      `;

      $('span:last-child', button).textContent =
        base.color || 'Default';

      button.addEventListener('click', () => {
        if (
          state.base &&
          base.variantId === state.base.variantId
        ) return;

        saveCurrentDesign();
        restoreDesignForBase(base);

        renderColors();
        renderPreview();
        updateUI();
      });

      list.appendChild(button);
    });

    $('[data-size]').textContent =
      state.base.size || 'Size not set';

    renderRange();
    renderPreview();
    updateUI();
  }

  function renderRange() {
    const value = $('[data-slider-value]');
    const maxLabel = $('[data-slider-max]');
    const help = $('[data-range-help]');

    if (!state.base) {
      countRange.disabled = true;
      countRange.min = '1';
      countRange.max = '1';
      countRange.value = '1';
      countRange.style.setProperty('--progress', '0%');

      value.textContent = '—';
      maxLabel.textContent = '—';
      help.textContent = 'Choose a chain first.';
      return;
    }

    const max = designCharmLimit();

    if (max < 1) {
      countRange.disabled = true;
      countRange.min = '1';
      countRange.max = '1';
      countRange.value = '1';
      countRange.style.setProperty('--progress', '0%');

      value.textContent = '—';
      maxLabel.textContent = '?';

      help.textContent =
        'This piece is not ready for charm placement yet.';
      return;
    }

    if (!state.targetCount) state.targetCount = 1;
    if (state.targetCount > max) state.targetCount = max;

    countRange.disabled = false;
    countRange.min = '1';
    countRange.max = String(max);
    countRange.value = String(state.targetCount);

    value.textContent = state.targetCount;
    maxLabel.textContent = max;

    const progress =
      max <= 1
        ? 100
        : ((state.targetCount - 1) / (max - 1)) * 100;

    countRange.style.setProperty(
      '--progress',
      `${progress}%`
    );

    help.textContent =
      `Choose from 1–${max} charms for this ${state.type}.`;
  }

  function startAnchorCalibration(event, anchor, index) {
    if (!anchorSetupMode || !state.base || !anchor.setPointerCapture) return;

    event.preventDefault();
    event.stopPropagation();

    const draft = ensureAnchorDraft();
    if (!draft[index]) return;

    const pointerId = event.pointerId;
    anchor.setPointerCapture(pointerId);

    const move = moveEvent => {
      if (moveEvent.pointerId !== pointerId) return;

      const rect = previewCanvas.getBoundingClientRect();

      const x = Math.max(
        0,
        Math.min(100, ((moveEvent.clientX - rect.left) / rect.width) * 100)
      );

      const y = Math.max(
        0,
        Math.min(100, ((moveEvent.clientY - rect.top) / rect.height) * 100)
      );

      draft[index] = {
        x: Number(x.toFixed(2)),
        y: Number(y.toFixed(2))
      };

      anchor.style.setProperty('--x', `${draft[index].x}%`);
      anchor.style.setProperty('--y', `${draft[index].y}%`);

      syncAnchorEditor();
    };

    const end = endEvent => {
      if (endEvent.pointerId !== pointerId) return;

      anchor.removeEventListener('pointermove', move);
      anchor.removeEventListener('pointerup', end);
      anchor.removeEventListener('pointercancel', end);

      try {
        anchor.releasePointerCapture(pointerId);
      } catch (e) {}

      syncAnchorEditor();
      renderPreview();
    };

    anchor.addEventListener('pointermove', move);
    anchor.addEventListener('pointerup', end);
    anchor.addEventListener('pointercancel', end);
  }

  function renderPreview() {
    sizePreviewCanvas();
    anchorLayer.innerHTML = '';

    const emptyDragPrompt = $('[data-empty-drag-prompt]');

    if (!state.base) {
      previewEmpty.hidden = false;
      chainImage.hidden = true;
      chainImage.removeAttribute('src');
      if (emptyDragPrompt) emptyDragPrompt.hidden = true;

      $('[data-preview-title]').textContent = 'Choose a chain';
      return;
    }

    previewEmpty.hidden = true;
    if (emptyDragPrompt) {
      emptyDragPrompt.hidden = selectedCount() > 0;
    }

    $('[data-preview-title]').textContent =
      state.base.title || `${state.base.style} · ${state.base.color}`;

    if (state.base.image) {
      chainImage.src = state.base.image;
      chainImage.alt = state.base.title;
      chainImage.hidden = false;
    } else {
      chainImage.hidden = true;
    }

    const layout = anchorLayout();

    /*
      Resize the placement array if a new manual layout changes anchor count.
    */
    if (state.placements.length !== layout.length) {
      const current = state.placements.slice();
      state.placements = new Array(layout.length).fill(null);

      current.slice(0, layout.length).forEach((item, index) => {
        if (item) state.placements[index] = item;
      });

      saveCurrentDesign();
    }

    layout.forEach((point, index) => {
      const anchor = document.createElement('button');
      anchor.type = 'button';
      anchor.className = 'ltsb__anchor';
      anchor.dataset.anchorIndex = String(index);
      anchor.style.setProperty('--x', `${point.x}%`);
      anchor.style.setProperty('--y', `${point.y}%`);
      anchor.setAttribute(
        'aria-label',
        `Anchor ${index + 1}`
      );

      if (anchorSetupMode) {
        anchor.textContent = String(index + 1);
        anchor.addEventListener('pointerdown', event => {
          startAnchorCalibration(event, anchor, index);
        });
      }

      const placement = state.placements[index];

      if (placement) {
        anchor.classList.add('is-filled');
      }

      anchor.addEventListener('click', event => {
        if (anchorSetupMode) {
          event.preventDefault();
          return;
        }

        /*
          Clicking an empty anchor after dragging from a charm card
          places that charm.
        */
        if (!placement && state.dragSource && state.dragSource.type === 'new') {
          placeCharm(state.dragSource.productId, index);
          state.dragSource = null;
          event.preventDefault();
        }
      });

      anchor.addEventListener('dragover', event => {
        if (anchorSetupMode) return;
        event.preventDefault();
        anchor.classList.add('is-drop-target');
      });

      anchor.addEventListener('dragleave', () => {
        anchor.classList.remove('is-drop-target');
      });

      anchor.addEventListener('drop', event => {
        if (anchorSetupMode) return;
        event.preventDefault();
        anchor.classList.remove('is-drop-target');

        let payload = null;

        try {
          payload = JSON.parse(
            event.dataTransfer.getData('application/json') ||
            event.dataTransfer.getData('text/plain')
          );
        } catch (e) {}

        if (!payload) payload = state.dragSource;
        if (!payload) return;

        if (payload.type === 'new') {
          placeCharm(payload.productId, index);
        }

        if (payload.type === 'placed') {
          movePlacement(
            Number(payload.anchorIndex),
            index
          );
        }

        state.dragSource = null;
        preview.classList.remove('is-dragging');
        $('[data-drag-note]').hidden = true;
      });

      anchorLayer.appendChild(anchor);

      if (!placement) return;

      const charm = charms.get(String(placement.productId));
      if (!charm) return;

      const placed = document.createElement('div');
      placed.className = 'ltsb__placed';
      placed.dataset.anchorIndex = String(index);
      placed.dataset.instanceId = placement.instanceId;

      const pathT = placementPathT(placement, index);
      const pathPoint =
        pathT !== null
          ? pathPointAtT(pathT)
          : null;

      const displayPoint = pathPoint
        ? {
            x: pathPoint.x * 100,
            y: pathPoint.y * 100
          }
        : point;

      const metrics = charmDisplayMetrics(charm);
      const connector = primaryCharmConnector(charm);
      const rotation =
        pathT !== null
          ? outwardCharmRotation(pathT, charm)
          : Number(charm?.geometry?.rotationOffset || 0);

      placed.dataset.pathT =
        pathT !== null ? String(pathT) : '';
      placed.dataset.rotation = String(rotation);
      placed.dataset.connectorX = String(connector.x);
      placed.dataset.connectorY = String(connector.y);

      placed.style.setProperty('--x', `${displayPoint.x}%`);
      placed.style.setProperty('--y', `${displayPoint.y}%`);
      placed.style.setProperty('--ltsb-placement-w', `${metrics.widthPx}px`);
      placed.style.setProperty('--ltsb-placement-h', `${metrics.heightPx}px`);
      placed.style.setProperty('--ltsb-attach-x', `${connector.x * 100}%`);
      placed.style.setProperty('--ltsb-attach-y', `${connector.y * 100}%`);
      placed.style.setProperty('--ltsb-rotation', `${rotation}deg`);
      placed.tabIndex = 0;
      placed.draggable = false;

      placed.innerHTML = `
        <span class="ltsb__placed-visual">
          <img src="${charm.image}" alt="">
        </span>
        <button
          type="button"
          class="ltsb__placed-remove"
          data-remove-placement
          aria-label="Remove ${escapeHtml(charm.title)}"
        >−</button>
      `;

      /*
        Pointer Events = touch + mouse drag for mobile.
      */
      placed.addEventListener('pointerdown', event => {
        if (event.target.closest('[data-remove-placement]')) return;

        startPointerMove(event, placed, index);
      });

      $('[data-remove-placement]', placed).addEventListener(
        'click',
        event => {
          event.preventDefault();
          event.stopPropagation();
          removePlacement(index);
        }
      );

      anchorLayer.appendChild(placed);
    });

    syncAnchorEditor();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function startPointerMove(event, element, fromIndex) {
    if (!state.base) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    const placement = state.placements[fromIndex];
    if (!placement) return;

    const charm = charms.get(String(placement.productId));
    if (!charm) return;

    const pointerId = event.pointerId;
    const startX = event.clientX;
    const startY = event.clientY;
    let active = false;
    let cancelledForScroll = false;
    let latestPosition = null;
    let holdTimer = null;

    const activate = () => {
      if (cancelledForScroll || active) return;
      active = true;

      element.classList.add('is-moving');
      preview.classList.add('is-dragging');
      $('[data-drag-note]').hidden = false;
      state.pointerDrag = { pointerId, fromIndex, element, moved: true };
    };

    if (event.pointerType === 'touch') {
      holdTimer = window.setTimeout(activate, dragHoldMs);
    }

    const onMove = moveEvent => {
      if (moveEvent.pointerId !== pointerId) return;

      const dx = moveEvent.clientX - startX;
      const dy = moveEvent.clientY - startY;
      const distance = Math.hypot(dx, dy);

      if (!active) {
        if (event.pointerType !== 'touch' && distance >= 5) {
          activate();
        } else if (event.pointerType === 'touch' && distance > 12) {
          cancelledForScroll = true;
          window.clearTimeout(holdTimer);
        }
      }

      if (!active) return;
      moveEvent.preventDefault();

      latestPosition = pointIsInsidePreview(moveEvent.clientX, moveEvent.clientY)
        ? nearestLegalPathPosition(
            moveEvent.clientX,
            moveEvent.clientY,
            placement.productId,
            fromIndex
          )
        : null;

      showFreeDropPreview(placement.productId, latestPosition);

      if (!latestPosition) return;

      const rotation = outwardCharmRotation(latestPosition.pathT, charm);
      element.style.setProperty('--x', `${latestPosition.x * 100}%`);
      element.style.setProperty('--y', `${latestPosition.y * 100}%`);
      element.style.setProperty('--ltsb-rotation', `${rotation}deg`);
    };

    const finish = upEvent => {
      if (upEvent.pointerId !== pointerId) return;
      window.clearTimeout(holdTimer);

      if (active && pointIsInsidePreview(upEvent.clientX, upEvent.clientY)) {
        latestPosition = nearestLegalPathPosition(
          upEvent.clientX,
          upEvent.clientY,
          placement.productId,
          fromIndex
        );
      }

      if (active && latestPosition) {
        movePlacement(
          fromIndex,
          Number(latestPosition.anchorIndex)
        );
      }

      cleanup();

      /*
        movePlacement already re-renders. If the drag was rejected, restore the
        original visual position now.
      */
      if (!(active && latestPosition)) {
        renderPreview();
        updateUI();
      }
    };

    const cleanup = () => {
      window.clearTimeout(holdTimer);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', finish, true);
      window.removeEventListener('pointercancel', cleanup, true);

      element.classList.remove('is-moving');
      preview.classList.remove('is-dragging');
      $('[data-drag-note]').hidden = true;
      clearDropPreview();
      state.pointerDrag = null;
    };

    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', finish, true);
    window.addEventListener('pointercancel', cleanup, true);
  }

  function nearestAnchorIndex(clientX, clientY, emptyOnly = false) {
    const anchors = $$('.ltsb__anchor', anchorLayer);
    if (!anchors.length) return -1;

    let bestIndex = -1;
    let bestDistance = Infinity;

    anchors.forEach(anchor => {
      const index = Number(anchor.dataset.anchorIndex);

      if (emptyOnly && state.placements[index]) {
        return;
      }

      const rect = anchor.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.top + rect.height / 2;

      const distance = Math.hypot(
        clientX - x,
        clientY - y
      );

      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    /*
      Generous touch target, but don't move a charm if the customer
      releases far away from the jewelry.
    */
    return bestDistance <= 72 ? bestIndex : -1;
  }

  function renderCards() {
    charmCards.forEach(card => {
      const qty = quantityForProduct(card.dataset.productId);
      const badge = $('[data-card-qty]', card);
      const action = $('[data-card-action]', card);
      const addButton = $('[data-card-add]', card);
      const available = card.dataset.available === 'true';

      card.classList.toggle('is-selected', qty > 0);

      if (badge) {
        badge.hidden = qty < 1;
        badge.textContent = qty;
      }

      if (action) {
        action.textContent =
          !available
            ? 'Sold out'
            : qty > 0
              ? 'Add +1'
              : 'Add';
      }

      if (addButton) {
        addButton.disabled = !available;
      }
    });
  }

  function searchMatches(text, query) {
    const q = clean(query);
    if (!q) return true;

    const haystack = clean(text);
    return q
      .split(/\s+/)
      .filter(Boolean)
      .every(term => haystack.includes(term));
  }

  function renderFilter() {
    let visible = 0;

    charmCards.forEach(card => {
      const collections = String(
        card.dataset.collections || ''
      )
        .split(/\s+/)
        .filter(Boolean);

      const collectionMatch =
        state.filter === 'all' ||
        collections.includes(state.filter);

      const queryMatch = searchMatches(
        card.dataset.search || card.dataset.title || '',
        state.searchQuery
      );

      card.hidden = !(collectionMatch && queryMatch);
      if (!card.hidden) visible += 1;
    });

    $$('[data-charm-row-shell]').forEach(shell => {
      const row = $('[data-charm-row]', shell);
      shell.hidden = !row || !$$('[data-charm]:not([hidden])', row).length;
    });

    const count = $('[data-search-count]');
    if (count) {
      count.textContent =
        `${visible} charm${visible === 1 ? '' : 's'}`;
    }

    const clear = $('[data-clear-search]');
    if (clear) clear.hidden = !state.searchQuery;
  }

  const stickyCart = $('[data-sticky-cart]');
  const cartToggle = $('[data-cart-toggle]');
  const resetDesignButtons = $$('[data-reset-design]');

  function resetCurrentDesign() {
    if (!state.base) return;

    const key = baseStorageKey();

    /*
      Reset means reset THIS chain only.
      Designs made on other bracelets / necklaces remain untouched.
    */
    if (key && state.designs[key]) {
      delete state.designs[key];
    }

    state.placements = new Array(maxAnchors()).fill(null);
    state.targetCount = maxAnchors() ? 1 : null;
    state.assembly = defaultAssemblyState();
    state.assemblyExplicit = false;
    state.dragSource = null;
    state.pointerDrag = null;

    if (countRange && state.targetCount) {
      countRange.value = String(state.targetCount);
    }

    persistBuilderState();

    closeCharmDetail();
    renderPreview();
    updateUI();
    setMessage('This chain has been reset. Your other saved designs are still here.');
  }

  resetDesignButtons.forEach(button => {
    button.addEventListener('click', resetCurrentDesign);
  });

  cartToggle?.addEventListener('click', () => {
    const expanded = stickyCart.classList.toggle('is-expanded');
    cartToggle.setAttribute('aria-expanded', String(expanded));
    cartToggle.setAttribute(
      'aria-label',
      expanded ? 'Hide design details' : 'Show design details'
    );
  });

  function placementSummary() {
    const occupied = state.placements
      .map((placement, index) => placement ? index + 1 : null)
      .filter(Boolean);

    if (!state.base) return 'Choose a chain to begin';
    if (!occupied.length) return 'No charms placed yet';

    return `${occupied.length} charm${occupied.length === 1 ? '' : 's'} placed exactly as shown`;
  }

  function renderStickyCart() {
    const thumbs = $('[data-checkout-thumbs]');
    const details = $('[data-checkout-details]');

    if (thumbs) {
      const items = [];

      if (state.base && state.base.image) {
        items.push({
          image: state.base.image,
          title: state.base.title,
          base: true
        });
      }

      state.placements.forEach(placement => {
        if (!placement) return;
        const charm = charms.get(String(placement.productId));
        if (charm && charm.image) {
          items.push({
            image: charm.image,
            title: charm.title,
            base: false
          });
        }
      });

      const visible = items.slice(0, 6);

      thumbs.innerHTML = visible.map(item => `
        <span class="ltsb__checkout-thumb" title="${escapeHtml(item.title)}">
          <img src="${escapeHtml(item.image)}" alt="">
        </span>
      `).join('');

      if (items.length > visible.length) {
        thumbs.insertAdjacentHTML(
          'beforeend',
          `<span class="ltsb__checkout-thumb ltsb__checkout-thumb--more">+${items.length - visible.length}</span>`
        );
      }

      if (!items.length) {
        thumbs.innerHTML = '<span class="ltsb__checkout-thumb ltsb__checkout-thumb--more">✦</span>';
      }
    }

    if (details) {
      if (!state.base) {
        details.textContent = 'Choose a chain to begin';
      } else {
        const charmWord = selectedCount() === 1 ? 'charm' : 'charms';
        details.textContent =
          `${state.base.title || state.base.style} · ${state.base.size} · ${selectedCount()} ${charmWord}`;
      }
    }

    const placement = $('[data-checkout-placement]');
    if (placement) {
      let assemblyLabel = `Choose how to finish it · ${placementSummary()}`;

      if (state.assembly === true && assemblyService.available) {
        assemblyLabel = `Built for you · ${placementSummary()}`;
      }

      if (state.assembly === false) {
        assemblyLabel = `You’ll build it · ${placementSummary()}`;
      }

      placement.textContent = assemblyLabel;
    }
  }

  function renderAssemblyChoice() {
    $$('[data-assembly-choice]').forEach(button => {
      const wantsAssembly =
        button.dataset.assemblyChoice === 'assembled';

      const active =
        wantsAssembly
          ? state.assembly === true
          : state.assembly === false;

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  $$('[data-assembly-choice]').forEach(button => {
    button.addEventListener('click', () => {
      if (button.disabled) return;

      const wantsAssembly =
        button.dataset.assemblyChoice === 'assembled';

      if (wantsAssembly && !assemblyService.available) {
        setMessage('Assembly Service is currently unavailable.', true);
        return;
      }

      state.assembly = wantsAssembly ? true : false;
      state.assemblyExplicit = true;
      saveCurrentDesign();
      updateUI();

      setMessage(
        wantsAssembly
          ? `We’ll build this exact Little Things design for you (${money(assemblyService.price)}).`
          : 'Your pieces will arrive separately, ready for you to build your Little Things.'
      );
    });
  });

  function updateUI() {
    renderCards();
    renderAssemblyChoice();
    renderRange();
    renderStickyCart();
    if (!$('[data-charm-modal]')?.hidden) renderModal();
    if (typeof detailModal !== 'undefined' && detailModal && !detailModal.hidden && detailProductId) {
      renderCharmDetail(detailProductId);
    }

    const selected = selectedCount();
    const target = state.targetCount;

    $('[data-selected-count]').textContent = selected;
    $('[data-selected-count-top]').textContent = selected;
    const previewCountLabel = $('.ltsb__preview-count span');
    if (previewCountLabel) previewCountLabel.textContent = selected === 1 ? 'charm' : 'charms';
    $('[data-target-count]').textContent = target || '—';

    if (state.base) {
      $('[data-summary]').textContent =
        `${state.base.title || state.base.style} · ${state.base.size}`;
    } else {
      $('[data-summary]').textContent =
        'Choose a chain to begin';
    }

    const jewelryPrice = state.base ? jewelrySubtotal() : 0;
    const fullBuilderPrice = state.base ? totalPrice() : 0;
    const assemblySelected =
      state.assembly === true && assemblyService.available;

    if ($('[data-total]')) {
      const previewPrice =
        previewAssemblyPriceMode === 'included'
          ? fullBuilderPrice
          : jewelryPrice;

      $('[data-total]').textContent =
        state.base ? money(previewPrice) : '—';
    }

    const assemblyNote = $('[data-preview-assembly-note]');
    if (assemblyNote) {
      const showSplitAssembly =
        state.base &&
        assemblySelected &&
        previewAssemblyPriceMode !== 'included';

      assemblyNote.hidden = !showSplitAssembly;
      assemblyNote.textContent = showSplitAssembly
        ? `+ ${money(assemblyService.price)} assembly`
        : '';
    }

    /* Footer beside Add to Bag shows the full builder price: jewelry + assembly.
       Required Connectors & Clasps stay hidden until cart / checkout. */
    if ($('[data-footer-total]')) {
      $('[data-footer-total]').textContent =
        state.base ? money(fullBuilderPrice) : '';
    }

    const add = $('[data-add-to-cart]');
    const status = $('[data-footer-status]');

    const assemblyChoiceMade =
      !assemblyChoiceRequired ||
      state.assembly === true ||
      state.assembly === false;

    const valid =
      Boolean(state.base) &&
      selected > 0 &&
      assemblyChoiceMade &&
      !state.adding;

    add.disabled = !valid;

    resetDesignButtons.forEach(button => {
      button.disabled = !state.base || selected === 0 || state.adding;
    });

    if (!state.base) {
      status.textContent = 'Choose your chain to start.';
      return;
    }

    if (!maxAnchors()) {
      status.textContent = 'This chain isn’t ready for customization yet.';
      return;
    }

    if (!target) {
      status.textContent = 'Choose how many charms you want.';
      return;
    }

    const remaining = target - selected;

    if (selected > 0 && assemblyChoiceRequired && state.assembly === null) {
      status.textContent = 'Choose how you want your Little Things to come to life.';
      return;
    }

    if (selected === 0) {
      status.textContent = 'Add at least one charm to your design.';
    } else if (remaining > 0) {
      status.textContent =
        `${selected} selected · add ${remaining} more, or add this design now.`;
    } else {
      status.textContent = 'Your design is ready.';
    }
  }

  /*
    Tap/click = auto-place on the next safe default anchor.
    Drag the charm IMAGE = drop anywhere along a legal charm area
    (mouse, pen or touch). Default anchors are not required for dragging.
  */
  function startSelectorPointerDrag(event, card) {
    if (
      card.dataset.available !== 'true' ||
      anchorSetupMode ||
      !state.base
    ) return;

    if (event.pointerType === 'mouse' && event.button !== 0) return;

    const handle = event.currentTarget;
    const startX = event.clientX;
    const startY = event.clientY;
    const pointerId = event.pointerId;

    let active = false;
    let finished = false;
    let ghost = null;
    let latestTarget = null;
    let lastX = startX;
    let lastY = startY;

    /*
      Pointer capture is important inside Shopify's theme-editor iframe.
      Without it, pointerup can be delivered to another editor layer after
      the cursor leaves the charm card, leaving the drag ghost visible and
      never committing the placement.
    */
    event.preventDefault();
    event.stopPropagation();

    try {
      handle.setPointerCapture(pointerId);
    } catch (e) {}

    const activate = moveEvent => {
      if (active) return;
      active = true;

      card.dataset.justDragged = 'true';
      card.dataset.suppressClickUntil = String(Date.now() + 700);

      const img = $('img', card);
      ghost = document.createElement('div');
      ghost.className = 'ltsb__selector-ghost';
      ghost.dataset.owner = section.dataset.sectionId || '';

      const sectionStyles = getComputedStyle(section);
      ghost.style.setProperty('--ltsb-accent', sectionStyles.getPropertyValue('--ltsb-accent'));
      ghost.style.setProperty('--ltsb-border', sectionStyles.getPropertyValue('--ltsb-border'));

      ghost.innerHTML = img
        ? `<img src="${img.currentSrc || img.src}" alt="">`
        : '';
      ghost.style.left = `${moveEvent.clientX}px`;
      ghost.style.top = `${moveEvent.clientY}px`;
      document.body.appendChild(ghost);

      preview.classList.add('is-dragging');
      $('[data-drag-note]').hidden = false;
    };

    const updateTarget = (clientX, clientY) => {
      lastX = clientX;
      lastY = clientY;

      if (!pointIsInsidePreview(clientX, clientY, 28)) {
        latestTarget = null;
        showFreeDropPreview(card.dataset.productId, null);
        return;
      }

      latestTarget = nearestLegalPathPosition(
        clientX,
        clientY,
        card.dataset.productId
      );

      showFreeDropPreview(card.dataset.productId, latestTarget);

      const targetIndex = latestTarget
        ? Number(latestTarget.anchorIndex)
        : -1;

      $$('.ltsb__anchor', anchorLayer).forEach(anchor => {
        anchor.classList.toggle(
          'is-drop-target',
          targetIndex >= 0 &&
          Number(anchor.dataset.anchorIndex) === targetIndex
        );
      });
    };

    const move = moveEvent => {
      if (moveEvent.pointerId !== pointerId || finished) return;

      const dx = moveEvent.clientX - startX;
      const dy = moveEvent.clientY - startY;
      const distance = Math.hypot(dx, dy);

      if (!active && distance >= 5) activate(moveEvent);
      if (!active) return;

      moveEvent.preventDefault();
      moveEvent.stopPropagation();

      if (ghost) {
        ghost.style.left = `${moveEvent.clientX}px`;
        ghost.style.top = `${moveEvent.clientY}px`;
      }

      updateTarget(moveEvent.clientX, moveEvent.clientY);
    };

    const cleanup = () => {
      handle.removeEventListener('pointermove', move);
      handle.removeEventListener('pointerup', finish);
      handle.removeEventListener('pointercancel', cancel);
      window.removeEventListener('pointermove', move, true);
      window.removeEventListener('pointerup', finish, true);
      window.removeEventListener('pointercancel', cancel, true);

      try {
        if (handle.hasPointerCapture(pointerId)) {
          handle.releasePointerCapture(pointerId);
        }
      } catch (e) {}

      if (ghost) {
        ghost.remove();
        ghost = null;
      }

      preview.classList.remove('is-dragging');
      $('[data-drag-note]').hidden = true;
      clearDropPreview();

      $$('.ltsb__anchor', anchorLayer).forEach(anchor =>
        anchor.classList.remove('is-drop-target')
      );
    };

    function finish(upEvent) {
      if (finished) return;
      if (
        upEvent.pointerId !== undefined &&
        upEvent.pointerId !== pointerId
      ) return;

      finished = true;

      /*
        Use the final coordinates when available. If Shopify's editor changes
        the event target at release, keep the last valid chain target instead
        of throwing the drop away.
      */
      if (active) {
        const ux = Number.isFinite(upEvent.clientX) ? upEvent.clientX : lastX;
        const uy = Number.isFinite(upEvent.clientY) ? upEvent.clientY : lastY;

        if (pointIsInsidePreview(ux, uy, 36)) {
          const finalTarget = nearestLegalPathPosition(
            ux,
            uy,
            card.dataset.productId
          );
          if (finalTarget) latestTarget = finalTarget;
        }
      }

      cleanup();

      if (!active) return;

      if (latestTarget) {
        const placed = placeCharmAtPath(
          card.dataset.productId,
          latestTarget.pathT
        );

        if (!placed) {
          setMessage(
            'That spot could not accept this charm. Try another usable part of the chain.',
            true
          );
        }
      } else {
        setMessage(
          'Drop the charm anywhere over a usable charm area on the chain.',
          true
        );
      }
    }

    function cancel(cancelEvent) {
      if (finished) return;
      if (
        cancelEvent.pointerId !== undefined &&
        cancelEvent.pointerId !== pointerId
      ) return;

      finished = true;
      cleanup();
    }

    /*
      Listen on BOTH the captured element and the window in capture phase.
      This is intentionally redundant: it makes release reliable in normal
      storefront pages and inside Shopify's theme editor.
    */
    handle.addEventListener('pointermove', move, { passive: false });
    handle.addEventListener('pointerup', finish);
    handle.addEventListener('pointercancel', cancel);
    window.addEventListener('pointermove', move, { capture: true, passive: false });
    window.addEventListener('pointerup', finish, true);
    window.addEventListener('pointercancel', cancel, true);
  }

  charmCards.forEach(card => {
    const addButton = $('[data-card-add]', card);
    const viewButton = $('[data-card-view]', card);
    const dragHandle = $('[data-charm-drag-handle]', card);

    let lastAddActivation = 0;

    const activateAdd = event => {
      event.preventDefault();
      event.stopPropagation();

      if (card.dataset.available !== 'true') return;

      /*
        Shopify's theme editor can occasionally consume the first normal
        click while it focuses a section. Activating on pointerup makes one
        physical press enough. The following click event is de-duplicated.
        Keyboard activation still works through click.
      */
      const now = Date.now();
      if (event.type === 'click' && now - lastAddActivation < 550) {
        return;
      }

      if (event.type === 'pointerup') {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        lastAddActivation = now;
      }

      const anchorIndex = safeAnchorIndexForCharm(
        card.dataset.productId
      );

      if (anchorIndex < 0) {
        setMessage(
          'There is no physically safe default spot left for that charm on this chain.',
          true
        );
        return;
      }

      placeCharm(card.dataset.productId, anchorIndex);
    };

    addButton?.addEventListener('pointerup', activateAdd);
    addButton?.addEventListener('click', activateAdd);

    viewButton?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      openCharmDetail(card.dataset.productId);
    });

    if (dragHandle) {
      dragHandle.addEventListener('pointerdown', event => {
        startSelectorPointerDrag(event, card);
      });

      dragHandle.draggable = false;
      dragHandle.addEventListener('dragstart', event => {
        event.preventDefault();
      });
    }
  });

  /*
    Desktop native drag/drop:
    release anywhere over the preview, then snap only to a legal empty
    physical link center. Link joints and configured no-charm zones are hard
    exclusions.
  */
  preview.addEventListener('dragover', event => {
    event.preventDefault();

    try {
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect =
          state.dragSource?.type === 'new' ? 'copy' : 'move';
      }
    } catch (e) {}

    clearDropPreview();

    const payload = state.dragSource;

    if (payload?.type === 'new') {
      const targetPosition = nearestLegalPathPosition(
        event.clientX,
        event.clientY,
        payload.productId
      );

      if (targetPosition) {
        showFreeDropPreview(payload.productId, targetPosition);
      }
    }

    let legalTargetIndex = -1;

    if (payload?.type === 'new') {
      const legalTarget = nearestLegalPathPosition(
        event.clientX,
        event.clientY,
        payload.productId
      );
      legalTargetIndex = legalTarget
        ? Number(legalTarget.anchorIndex)
        : -1;
    } else if (payload?.type === 'placed') {
      const sourceIndex = Number(payload.anchorIndex);
      const sourcePlacement = state.placements[sourceIndex];
      if (sourcePlacement) {
        const legalTarget = nearestLegalPathPosition(
          event.clientX,
          event.clientY,
          sourcePlacement.productId,
          sourceIndex
        );
        legalTargetIndex = legalTarget
          ? Number(legalTarget.anchorIndex)
          : -1;
      }
    }

    $$('.ltsb__anchor', anchorLayer).forEach(anchor => {
      anchor.classList.toggle(
        'is-drop-target',
        legalTargetIndex >= 0 &&
        Number(anchor.dataset.anchorIndex) === legalTargetIndex
      );
    });
  });

  preview.addEventListener('drop', event => {
    event.preventDefault();

    let payload = null;

    try {
      payload = JSON.parse(
        event.dataTransfer.getData('application/json') ||
        event.dataTransfer.getData('text/plain')
      );
    } catch (e) {}

    if (!payload) payload = state.dragSource;
    if (!payload) return;

    if (payload.type === 'new') {
      const targetPosition = nearestLegalPathPosition(
        event.clientX,
        event.clientY,
        payload.productId
      );

      if (targetPosition) {
        placeCharmAtPath(
          payload.productId,
          targetPosition.pathT
        );
      }
    }

    if (payload.type === 'placed') {
      const sourceIndex = Number(payload.anchorIndex);
      const placement = state.placements[sourceIndex];

      if (placement) {
        const targetPosition = nearestLegalPathPosition(
          event.clientX,
          event.clientY,
          placement.productId,
          sourceIndex
        );

        if (targetPosition) {
          movePlacement(
            sourceIndex,
            Number(targetPosition.anchorIndex)
          );
        }
      }
    }

    state.dragSource = null;
    preview.classList.remove('is-dragging');
    $('[data-drag-note]').hidden = true;
    clearDropPreview();
  });

  $$('[data-type]').forEach(button => {
    button.addEventListener('click', () => {
      const nextType = button.dataset.type;
      if (nextType === state.type) return;

      /*
        Bracelet and necklace designs are independent.
        Save the one we're leaving before changing product type.
      */
      saveCurrentDesign();

      state.type = nextType;
      state.style = null;
      state.base = null;
      state.targetCount = null;
      state.placements = [];

      $$('[data-type]').forEach(item =>
        item.classList.toggle(
          'is-active',
          item.dataset.type === nextType
        )
      );

      renderStyles();
      renderPreview();
      updateUI();
      persistBuilderState();
    });
  });

  $$('[data-filter]').forEach(button => {
    button.addEventListener('click', () => {
      state.filter = button.dataset.filter;

      $$('[data-filter]').forEach(item =>
        item.classList.toggle(
          'is-active',
          item === button
        )
      );

      renderFilter();
      button.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    });
  });

  $('[data-change-selections]')?.addEventListener('click', () => {
    $('.ltsb__steps')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });

  const mainSearch = $('[data-charm-search]');

  mainSearch?.addEventListener('input', event => {
    state.searchQuery = event.target.value || '';
    renderFilter();
  });

  $('[data-clear-search]')?.addEventListener('click', () => {
    state.searchQuery = '';
    if (mainSearch) {
      mainSearch.value = '';
      mainSearch.focus();
    }
    renderFilter();
  });

  function wireHorizontalRail(scroller, prev, next, amount = .8) {
    if (!scroller || !prev || !next) return;

    const sync = () => {
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= maxScroll - 2;
    };

    prev.addEventListener('click', () => {
      scroller.scrollBy({
        left: -Math.max(150, scroller.clientWidth * amount),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', () => {
      scroller.scrollBy({
        left: Math.max(150, scroller.clientWidth * amount),
        behavior: 'smooth'
      });
    });

    scroller.addEventListener('scroll', sync, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(sync);
      observer.observe(scroller);
    }

    requestAnimationFrame(sync);
    setTimeout(sync, 180);
  }

  wireHorizontalRail(
    $('[data-style-list]'),
    $('[data-style-prev]'),
    $('[data-style-next]'),
    .72
  );

  wireHorizontalRail(
    $('[data-tabs]'),
    $('[data-filter-prev]'),
    $('[data-filter-next]'),
    .8
  );

  $$('[data-charm-row-shell]').forEach(shell => {
    wireHorizontalRail(
      $('[data-charm-row]', shell),
      $('[data-row-prev]', shell),
      $('[data-row-next]', shell),
      .78
    );
  });

  const detailModal = $('[data-charm-detail-modal]');
  let detailProductId = null;

  function syncOverlayStacking() {
    const allModal = $('[data-charm-modal]');
    const anyOpen =
      Boolean(detailModal && !detailModal.hidden) ||
      Boolean(allModal && !allModal.hidden);

    section.classList.toggle('is-overlay-open', anyOpen);
    document.body.classList.toggle('ltsb-modal-open', anyOpen);

    if (anyOpen) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.removeProperty('overflow');
    }
  }

  function setDetailField(wrapperSelector, valueSelector, value) {
    const wrap = $(wrapperSelector);
    const target = $(valueSelector);
    if (!wrap || !target) return;

    const hasValue = Boolean(String(value || '').trim());
    wrap.hidden = !hasValue;
    target.textContent = hasValue ? value : '';
  }

  function metaValues(value) {
    if (Array.isArray(value)) {
      return value.map(item => String(item || '').trim()).filter(Boolean);
    }

    const raw = String(value || '').trim();
    if (!raw) return [];

    if (raw.startsWith('[') && raw.endsWith(']')) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed.map(item => String(item || '').trim()).filter(Boolean);
        }
      } catch (e) {}
    }

    const cleaned = raw
      .replace(/^\[|\]$/g, '')
      .replace(/["']/g, '')
      .trim();

    if (cleaned.includes('•')) {
      return cleaned.split('•').map(item => item.trim()).filter(Boolean);
    }

    if (cleaned.includes(',')) {
      return cleaned.split(',').map(item => item.trim()).filter(Boolean);
    }

    return [cleaned];
  }

  function detailFact(label, value, icon = '✦', wide = false, maxTokens = 8) {
    const values = metaValues(value);
    if (!values.length) return '';

    const shown = values.slice(0, maxTokens);
    const remaining = Math.max(0, values.length - shown.length);

    const tokens = shown
      .map(item => `<span class="ltsb__detail-token">${escapeHtml(item)}</span>`)
      .join('');

    const more = remaining
      ? `<span class="ltsb__detail-token ltsb__detail-token--more">+${remaining} more</span>`
      : '';

    return `
      <div class="ltsb__detail-fact${wide ? ' ltsb__detail-fact--wide' : ''}">
        <span class="ltsb__detail-fact-icon" aria-hidden="true">${escapeHtml(icon)}</span>
        <div class="ltsb__detail-fact-copy">
          <b>${escapeHtml(label)}</b>
          <div class="ltsb__detail-fact-values">${tokens}${more}</div>
        </div>
      </div>
    `;
  }

  function renderCharmDetail(productId) {
    const charm = charms.get(String(productId));
    if (!charm || !detailModal) return;

    detailProductId = String(productId);

    const image = $('[data-detail-image]');
    if (image) {
      image.src = charm.image || '';
      image.alt = charm.title || '';
    }

    const language = $('[data-detail-language]');
    if (language) {
      language.hidden = !charm.language;
      language.textContent = charm.language || '';
    }

    $('[data-detail-title]').textContent = charm.title || '';
    $('[data-detail-price]').textContent = money(charm.price);

    const description = $('[data-detail-description]');
    if (description) {
      description.hidden = !charm.description;
      description.textContent = charm.description || '';
    }

    setDetailField('[data-detail-vibe-wrap]', '[data-detail-vibe]', charm.vibe);
    setDetailField('[data-detail-meaning-wrap]', '[data-detail-meaning]', charm.meaning);
    setDetailField('[data-detail-make-yours-wrap]', '[data-detail-make-yours]', charm.makeYours);

    const facts = $('[data-detail-facts]');
    if (facts) {
      facts.innerHTML = [
        detailFact('Symbol', charm.symbol, '✦'),
        detailFact('Season', charm.season, '☼'),
        detailFact('Emotional worlds', charm.emotionalWorlds, '♡', true),
        detailFact('Perfect for', charm.giftFor, '⌁', true),
        detailFact('Collections', charm.charmCollections, '◫', true),
        detailFact('Color family', charm.colorFamily, '◌'),
        detailFact('Related themes', charm.aiKeywords, '✧', true, 8)
      ].filter(Boolean).join('');
    }

    const add = $('[data-detail-add]');
    if (add) {
      const qty = quantityForProduct(charm.productId);
      const maxed =
        !state.base ||
        selectedCount() >= designCharmLimit() ||
        !charm.available;

      add.disabled = maxed;
      add.textContent = !charm.available
        ? 'Sold out'
        : qty
          ? `Add another · ${qty}`
          : 'Add to my design';
    }
  }

  function openCharmDetail(productId) {
    if (!detailModal) return;

    renderCharmDetail(productId);
    detailModal.hidden = false;
    detailModal.setAttribute('aria-hidden', 'false');
    syncOverlayStacking();
  }

  function closeCharmDetail() {
    if (!detailModal) return;

    detailModal.hidden = true;
    detailModal.setAttribute('aria-hidden', 'true');
    detailProductId = null;

    syncOverlayStacking();
  }

  $$('[data-close-charm-detail]').forEach(button => {
    button.addEventListener('click', closeCharmDetail);
  });

  $('[data-detail-add]')?.addEventListener('click', () => {
    if (!detailProductId) return;

    const anchorIndex = firstEmptyAnchor();

    if (anchorIndex < 0) {
      setMessage('Every charm spot is already filled.', true);
      return;
    }

    if (placeCharm(detailProductId, anchorIndex)) {
      renderCharmDetail(detailProductId);
    }
  });

  const modal = $('[data-charm-modal]');
  const modalSearch = $('[data-modal-search]');
  const modalGrid = $('[data-modal-grid]');

  function modalCharmMarkup(charm) {
    const qty = quantityForProduct(charm.productId);
    const maxed =
      !state.base ||
      selectedCount() >= designCharmLimit() ||
      !charm.available;

    return `
      <article
        class="ltsb__modal-card"
        data-modal-charm="${escapeHtml(charm.productId)}"
        data-modal-search="${escapeHtml(charm.searchText)}"
      >
        <div class="ltsb__modal-card-image">
          ${charm.image ? `<img src="${escapeHtml(charm.image)}" alt="${escapeHtml(charm.title)}">` : ''}
          ${charm.language ? `<span class="ltsb__language-badge">${escapeHtml(charm.language)}</span>` : ''}
          ${qty ? `<span class="ltsb__charm-qty">${qty}</span>` : ''}
        </div>

        <div class="ltsb__modal-card-title">
          <strong>${escapeHtml(charm.title)}</strong>
          <small>${money(charm.price)}</small>
        </div>

        <div class="ltsb__modal-story">
          ${charm.vibe ? `
            <div>
              <b>The Vibe</b>
              <span>${escapeHtml(charm.vibe)}</span>
            </div>
          ` : ''}

          ${charm.meaning ? `
            <div>
              <b>The Meaning</b>
              <span>${escapeHtml(charm.meaning)}</span>
            </div>
          ` : ''}

          ${charm.makeYours ? `
            <div>
              <b>Make It Yours</b>
              <span>${escapeHtml(charm.makeYours)}</span>
            </div>
          ` : ''}
        </div>

        <div class="ltsb__modal-actions">
          <button
            type="button"
            class="ltsb__modal-add"
            data-modal-add="${escapeHtml(charm.productId)}"
            ${maxed ? 'disabled' : ''}
          >
            ${qty ? `Add another · ${qty}` : 'Add to my design'}
          </button>

          <button
            type="button"
            class="ltsb__modal-view"
            data-modal-view="${escapeHtml(charm.productId)}"
          >
            View details
          </button>
        </div>
      </article>
    `;
  }

  function renderModal() {
    if (!modalGrid) return;

    const query = state.modalSearchQuery || '';
    const matches = Array.from(charms.values())
      .filter(charm => searchMatches(charm.searchText || charm.title, query));

    modalGrid.innerHTML = matches
      .map(modalCharmMarkup)
      .join('');

    const count = $('[data-modal-count]');
    if (count) {
      count.textContent =
        `${matches.length} charm${matches.length === 1 ? '' : 's'}`;
    }

    const empty = $('[data-modal-empty]');
    if (empty) empty.hidden = matches.length > 0;

    const clear = $('[data-clear-modal-search]');
    if (clear) clear.hidden = !query;

    $$('[data-modal-add]', modalGrid).forEach(button => {
      button.addEventListener('click', () => {
        const productId = button.dataset.modalAdd;
        const anchorIndex = safeAnchorIndexForCharm(productId);

        if (anchorIndex < 0) {
          setMessage(
            'There is no physically safe default spot left for that charm on this chain.',
            true
          );
          return;
        }

        placeCharm(productId, anchorIndex);
        renderModal();
      });
    });

    $$('[data-modal-view]', modalGrid).forEach(button => {
      button.addEventListener('click', () => {
        openCharmDetail(button.dataset.modalView);
      });
    });
  }

  function openCharmModal() {
    if (!modal) return;

    state.modalSearchQuery = state.searchQuery || '';
    if (modalSearch) modalSearch.value = state.modalSearchQuery;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    syncOverlayStacking();

    renderModal();

    requestAnimationFrame(() => {
      modalSearch?.focus();
    });
  }

  function closeCharmModal() {
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    syncOverlayStacking();
  }

  $('[data-view-all]')?.addEventListener('click', openCharmModal);

  const browseToggle = $('[data-browse-toggle]');
  const charmRows = $('[data-charm-rows]');

  function syncCharmBrowseMode() {
    if (!charmRows || !browseToggle) return;

    const grid = state.browseMode === 'grid';
    charmRows.classList.toggle('is-grid', grid);
    browseToggle.setAttribute('aria-pressed', grid ? 'true' : 'false');

    const label = $('span:first-child', browseToggle);
    const icon = $('span:last-child', browseToggle);

    if (label) label.textContent = grid ? 'Carousel view' : 'Browse all';
    if (icon) icon.textContent = grid ? '↔' : '▦';

    if (!grid) {
      $$('[data-charm-row-shell]').forEach(shell => {
        const row = $('[data-charm-row]', shell);
        row?.dispatchEvent(new Event('scroll'));
      });
    }
  }

  browseToggle?.addEventListener('click', () => {
    state.browseMode = state.browseMode === 'grid' ? 'carousel' : 'grid';
    syncCharmBrowseMode();
    renderFilter();
  });

  syncCharmBrowseMode();

  $$('[data-close-charm-modal]').forEach(button => {
    button.addEventListener('click', closeCharmModal);
  });

  modalSearch?.addEventListener('input', event => {
    state.modalSearchQuery = event.target.value || '';
    renderModal();
  });

  $('[data-clear-modal-search]')?.addEventListener('click', () => {
    state.modalSearchQuery = '';
    if (modalSearch) {
      modalSearch.value = '';
      modalSearch.focus();
    }
    renderModal();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;

    if (detailModal && !detailModal.hidden) {
      closeCharmDetail();
      return;
    }

    if (modal && !modal.hidden) {
      closeCharmModal();
    }
  });

  preview.addEventListener('pointerdown', event => {
    if (!event.target.closest('.ltsb__placed')) {
      $$('.ltsb__placed.is-controls-open', anchorLayer).forEach(item =>
        item.classList.remove('is-controls-open')
      );
    }
  });

  document.addEventListener('pointerdown', event => {
    if (!event.target.closest(`#${section.id} .ltsb__placed`)) {
      $$('.ltsb__placed.is-controls-open', anchorLayer).forEach(item =>
        item.classList.remove('is-controls-open')
      );
    }
  });

  countRange.addEventListener('input', event => {
    if (!state.base) return;

    const max = designCharmLimit();
    if (!max) return;

    const requested = Math.max(
      1,
      Math.min(
        max,
        Number(event.target.value || 1)
      )
    );

    const selected = selectedCount();

    if (requested < selected) {
      state.targetCount = selected;
      countRange.value = String(selected);

      setMessage(
        `Remove ${selected - requested} charm${selected - requested === 1 ? '' : 's'} before lowering the total to ${requested}.`,
        true
      );
    } else {
      state.targetCount = requested;
      setMessage('');
    }

    saveCurrentDesign();
    updateUI();
  });

  function designManifest(designId) {
    const layout = anchorLayout();

    return {
      version: 1,
      designId,
      base: state.base ? {
        productId: state.base.productId,
        variantId: state.base.variantId,
        title: state.base.title,
        style: state.base.style,
        size: state.base.size,
        color: state.base.color,
        image: state.base.image
      } : null,
      anchors: layout.map((point, index) => ({
        index: index + 1,
        x: Number(point.x),
        y: Number(point.y)
      })),
      placements: state.placements
        .map((placement, anchorIndex) => {
          if (!placement) return null;
          const charm = charms.get(String(placement.productId));
          if (!charm) return null;

          const point = layout[anchorIndex] || { x: 50, y: 50 };
          const pathT = placementPathT(placement, anchorIndex);
          const pathPoint =
            pathT !== null
              ? pathPointAtT(pathT)
              : null;

          return {
            anchor: anchorIndex + 1,
            x: pathPoint ? Number(pathPoint.x * 100) : Number(point.x),
            y: pathPoint ? Number(pathPoint.y * 100) : Number(point.y),
            pathT,
            rotation:
              pathT !== null
                ? outwardCharmRotation(pathT, charm)
                : Number(charm?.geometry?.rotationOffset || 0),
            productId: charm.productId,
            variantId: charm.variantId,
            title: charm.title,
            image: charm.image
          };
        })
        .filter(Boolean)
    };
  }

  function loadCanvasImage(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(`Could not load design image: ${src}`));
      image.src = src;
    });
  }

  function canvasThemeColor(name, fallback) {
    const value = getComputedStyle(section).getPropertyValue(name).trim();
    return value || fallback;
  }

  async function createDesignPreviewBlob() {
    if (!state.base || !state.base.image || !previewCanvas) return null;

    /*
      GEOMETRY-AWARE, EDGE-SAFE ORDER IMAGE
      -------------------------------------
      Build the finished product from the same transparent chain/charm assets
      used by the storefront. Charm size, connector position and rotation come
      from the Product Configurator geometry.

      Before drawing, calculate the complete rotated design bounds. If any
      charm hangs below/left/right/top of the chain image, the entire design is
      scaled and centered together so NOTHING is cropped in the 1200x1200
      order/assembly image.
    */
    const size = 1200;
    const padding = 54;

    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) return null;

    const soft = canvasThemeColor('--ltsb-soft', '#F8EFE7');

    ctx.fillStyle = soft;
    ctx.fillRect(0, 0, size, size);

    const glow = ctx.createRadialGradient(
      size * .5,
      size * .46,
      0,
      size * .5,
      size * .46,
      size * .48
    );

    glow.addColorStop(0, 'rgba(255,255,255,.90)');
    glow.addColorStop(.66, 'rgba(255,255,255,.28)');
    glow.addColorStop(1, 'rgba(255,255,255,0)');

    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, size, size);

    try {
      const chain = await loadCanvasImage(state.base.image);
      const previewBaseSize = Math.max(
        1,
        previewCanvas.offsetWidth || previewCanvas.clientWidth || 1
      );

      const specs = [];

      for (let anchorIndex = 0; anchorIndex < state.placements.length; anchorIndex++) {
        const placement = state.placements[anchorIndex];
        if (!placement) continue;

        const charm = charms.get(String(placement.productId));
        if (!charm || !charm.image) continue;

        const layoutPoint =
          anchorLayout()[anchorIndex] || { x: 50, y: 50 };

        const pathT = placementPathT(placement, anchorIndex);
        const pathPoint =
          pathT !== null
            ? pathPointAtT(pathT)
            : null;

        const x =
          (pathPoint ? pathPoint.x : Number(layoutPoint.x) / 100) * size;

        const y =
          (pathPoint ? pathPoint.y : Number(layoutPoint.y) / 100) * size;

        const metrics = charmDisplayMetrics(charm);
        const width = metrics.widthPx / previewBaseSize * size;
        const height = metrics.heightPx / previewBaseSize * size;
        const connector = primaryCharmConnector(charm);

        const rotation =
          pathT !== null
            ? outwardCharmRotation(pathT, charm)
            : Number(charm?.geometry?.rotationOffset || 0);

        specs.push({
          charm,
          image: await loadCanvasImage(charm.image),
          x,
          y,
          width,
          height,
          connector,
          rotation
        });
      }

      /*
        The logical chain image occupies 0..1200 in both directions. Include
        that region plus every ROTATED charm in the complete bounds.
      */
      let minX = 0;
      let minY = 0;
      let maxX = size;
      let maxY = size;

      const rotatePoint = (x, y, radians) => ({
        x: x * Math.cos(radians) - y * Math.sin(radians),
        y: x * Math.sin(radians) + y * Math.cos(radians)
      });

      specs.forEach(spec => {
        const cx = spec.connector.x * spec.width;
        const cy = spec.connector.y * spec.height;
        const radians = spec.rotation * Math.PI / 180;

        const corners = [
          { x: -cx, y: -cy },
          { x: spec.width - cx, y: -cy },
          { x: spec.width - cx, y: spec.height - cy },
          { x: -cx, y: spec.height - cy }
        ];

        corners.forEach(corner => {
          const rotated = rotatePoint(corner.x, corner.y, radians);
          const px = spec.x + rotated.x;
          const py = spec.y + rotated.y;

          minX = Math.min(minX, px);
          minY = Math.min(minY, py);
          maxX = Math.max(maxX, px);
          maxY = Math.max(maxY, py);
        });
      });

      const boundsWidth = Math.max(1, maxX - minX);
      const boundsHeight = Math.max(1, maxY - minY);
      const available = size - padding * 2;

      const fitScale = Math.min(
        1,
        available / boundsWidth,
        available / boundsHeight
      );

      const boundsCenterX = (minX + maxX) / 2;
      const boundsCenterY = (minY + maxY) / 2;

      ctx.save();
      ctx.translate(size / 2, size / 2);
      ctx.scale(fitScale, fitScale);
      ctx.translate(-boundsCenterX, -boundsCenterY);

      // Always use the transparent configured chain image.
      ctx.drawImage(chain, 0, 0, size, size);

      specs.forEach(spec => {
        ctx.save();
        ctx.translate(spec.x, spec.y);
        ctx.rotate(spec.rotation * Math.PI / 180);

        ctx.drawImage(
          spec.image,
          -spec.connector.x * spec.width,
          -spec.connector.y * spec.height,
          spec.width,
          spec.height
        );

        ctx.restore();
      });

      ctx.restore();

      return await new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          if (blob) resolve(blob);
          else reject(new Error('The browser could not create the design PNG.'));
        }, 'image/png');
      });
    } catch (error) {
      console.warn('[Little Things] Could not generate preview PNG:', error);
      return null;
    }
  }

  async function uploadDesignPreview(designId) {
    /* Same relative endpoint works on the dev store and wearlittlethings.com. */
    const endpoint = String(
      section.dataset.designUploadEndpoint ||
      '/apps/little-things/design-upload'
    ).trim();

    if (!endpoint) return '';

    const blob = await createDesignPreviewBlob();

    if (!blob) {
      throw new Error('We could not prepare your finished design image.');
    }

    const form = new FormData();

    /* IMPORTANT: the Little Things app endpoint expects camelCase designId. */
    form.append('designId', designId);
    form.append('file', blob, `${designId}.png`);

    let response;

    try {
      response = await fetch(endpoint, {
        method: 'POST',
        body: form,
        headers: {
          'Accept': 'application/json'
        }
      });
    } catch (error) {
      console.warn('[Little Things] Design preview upload request failed:', error);
      throw new Error('We could not reach the design-image service. Please try again.');
    }

    const raw = await response.text();
    let result = null;

    if (raw) {
      try {
        result = JSON.parse(raw);
      } catch (error) {
        console.warn('[Little Things] Design preview returned non-JSON:', raw);
      }
    }

    if (!response.ok) {
      const message =
        result && (result.error || result.message)
          ? String(result.error || result.message)
          : `Design image upload failed (${response.status}).`;

      throw new Error(message);
    }

    const url = String(
      result && (
        result.url ||
        result.image_url ||
        result.cdn_url
      ) || ''
    ).trim();

    if (!url) {
      throw new Error('Shopify uploaded the design but did not return its image URL.');
    }

    const returnedDesignId = String(
      result && (result.designId || result.design_id) || ''
    ).trim();

    if (returnedDesignId && returnedDesignId !== designId) {
      console.warn(
        '[Little Things] Upload endpoint returned a different design ID:',
        returnedDesignId,
        'expected:',
        designId
      );
    }

    return url;
  }

  async function addDesignToCart() {
    const actualSelected = selectedCount();

    if (
      !state.base ||
      actualSelected < 1 ||
      state.adding
    ) return;

    if (assemblyChoiceRequired && state.assembly === null) {
      setMessage('Choose how you want your Little Things to come to life first.', true);
      $('.ltsb__step--assembly')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return;
    }

    if (
      state.assembly === true &&
      (!assemblyService.available || !assemblyService.variantId)
    ) {
      setMessage(
        'Assembly Service is selected but is not available. Choose loose packaging or contact us.',
        true
      );
      return;
    }

    const hardware = hardwareRequirementsForDesign();
    const roundingHardware = hardware.rounding > 0
      ? resolveHardwareVariant('rounding', hardware.color)
      : null;
    const additionalHardware = hardware.additional > 0
      ? resolveHardwareVariant('additional', hardware.color)
      : null;

    if (
      hardware.rounding > 0 &&
      (!roundingHardware || Number(roundingHardware.price) !== 1)
    ) {
      setMessage(
        `Connectors & Clasps needs an available ${hardware.color} / Rounding variant priced at exactly $0.01.`,
        true
      );
      return;
    }

    if (
      hardware.additional > 0 &&
      (!additionalHardware || Number(additionalHardware.price) !== 0)
    ) {
      setMessage(
        `Connectors & Clasps needs an available ${hardware.color} / Additional variant priced at exactly $0.00.`,
        true
      );
      return;
    }

    /* If the customer planned more charms than they actually added,
       checkout uses the real design and automatically lowers the slider. */
    if (state.targetCount !== actualSelected) {
      state.targetCount = actualSelected;
      if (countRange) countRange.value = String(actualSelected);
      saveCurrentDesign();
      renderRange();
      updateUI();
    }

    const addButton = $('[data-add-to-cart]');
    const addButtonLabel = addButton
      ? addButton.querySelector('span:last-child')
      : null;

    const originalLabel = addButtonLabel
      ? addButtonLabel.textContent
      : 'Add My Design to Bag';

    const setAddButtonLabel = label => {
      if (addButtonLabel) addButtonLabel.textContent = label;
      else if (addButton) addButton.textContent = label;
    };

    state.adding = true;
    addButton.disabled = true;
    setAddButtonLabel('Creating preview…');
    setMessage('Preparing your finished Little Things design…');

    /* Explicitly persist before any network request. If the upload fails, the
       customer can retry without losing the chain or charm placements. */
    saveCurrentDesign();

    const designId =
      `LT-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;

    const manifest = designManifest(designId);

    let designImageUrl = '';

    try {
      designImageUrl = await uploadDesignPreview(designId);
    } catch (error) {
      console.error('[Little Things] Finished design image failed:', error);

      setMessage(
        `${error && error.message ? error.message : 'We could not prepare your finished design image.'} Your design is still saved — please try again.`,
        true
      );

      setAddButtonLabel(originalLabel);
      state.adding = false;
      updateUI();
      return;
    }

    setAddButtonLabel('Adding to bag…');
    setMessage('Adding your finished Little Things design…');

    const layout = anchorLayout();

    /*
      Compact customer-cart summary.

      When Assembly Service is selected, Shopify's Cart Transform merges the
      base + charms + Assembly Service + required hardware into one parent
      "Your Little Things" line. The original component lines then disappear
      from /cart.js, so this private JSON summary preserves everything the
      custom cart drawer needs for its rendered-image card and dropdown.
    */
    const cartDetails = {
      v: 2,

      // Base/piece information.
      b: state.base?.title || '',
      t: state.type || '',
      bp: Number(state.base?.price || 0),

      // Charm rows: [anchor, title, image, unit price in cents, connector count].
      c: manifest.placements.map(item => {
        const charm = charms.get(String(item.productId));

        return [
          Number(item.anchor),
          String(item.title || charm?.title || 'Charm'),
          String(item.image || charm?.image || ''),
          Number(charm?.price || 0),
          Math.max(
            1,
            Array.isArray(charm?.geometry?.connectors)
              ? charm.geometry.connectors.length
              : 1
          )
        ];
      }),

      // Backward-compatible paid hardware row: [quantity, unit price].
      h:
        hardware.rounding > 0
          ? [Number(hardware.rounding), 1]
          : null,

      // V2 physical extra connectors/clasps that do not add price.
      hf:
        hardware.additional > 0
          ? [Number(hardware.additional), 0]
          : null,

      // Hardware finish selected automatically from the configured chain.
      hc: hardware.color,

      // Assembly Service: [title, price in cents].
      a:
        state.assembly && assemblyService.available
          ? [
              String(assemblyService.title || 'Assembly Service'),
              Number(assemblyService.price || 0)
            ]
          : null
    };

    const items = [
      {
        id: state.base.variantId,
        quantity: 1,
        properties: {
          '_lt_design_id': designId,
          '_lt_role': 'base',
          '_lt_hardware_color': hardware.color,
          '_lt_chain_image': state.base.image || '',
          '_lt_builder_geometry_version': String(state.base?.geometry?.version || ''),
          '_lt_design_image_url': designImageUrl,
          '_lt_cart_details': JSON.stringify(cartDetails),
          '_lt_anchor_layout': JSON.stringify(
            layout.map((point, index) => ({
              a: index + 1,
              x: Number(point.x),
              y: Number(point.y)
            }))
          ),
          '_lt_design_manifest': JSON.stringify({
            v: 1,
            anchors: manifest.anchors.map(item => [item.index, item.x, item.y]),
            placements: manifest.placements.map(item => [
              item.anchor,
              item.variantId
            ])
          }),
          'Design': 'Build Your Little Things',
          'Chain': state.base.title || `${state.base.style} · ${state.base.color}`,
          'Size': state.base.size,
          'Charms': String(actualSelected)
        }
      }
    ];

    /*
      Every placed charm is its own component line.
      Even if the same charm is used twice, its anchor position is different,
      so Shopify keeps the component lines distinct. This makes the exact design
      reconstructable in cart, checkout extensions, order status, and Admin UI.
    */
    const builderCanvasRect = previewCanvas.getBoundingClientRect();

    state.placements.forEach((placement, anchorIndex) => {
      if (!placement) return;

      const charm = charms.get(String(placement.productId));
      if (!charm) return;

      const fallbackPoint = layout[anchorIndex] || { x: 50, y: 50 };
      const pathT = placementPathT(placement, anchorIndex);
      const dynamicPoint =
        pathT !== null
          ? pathPointAtT(pathT)
          : null;

      const point = dynamicPoint
        ? {
            x: dynamicPoint.x * 100,
            y: dynamicPoint.y * 100
          }
        : fallbackPoint;

      const placedEl = $(`.ltsb__placed[data-anchor-index="${anchorIndex}"]`, anchorLayer);

      let renderX = '';
      let renderY = '';
      let renderW = '';
      let renderH = '';

      if (
        placedEl &&
        builderCanvasRect.width > 0 &&
        builderCanvasRect.height > 0
      ) {
        const rect = placedEl.getBoundingClientRect();

        renderX = String(
          Number((((rect.left - builderCanvasRect.left) / builderCanvasRect.width) * 100).toFixed(4))
        );
        renderY = String(
          Number((((rect.top - builderCanvasRect.top) / builderCanvasRect.height) * 100).toFixed(4))
        );
        renderW = String(
          Number(((rect.width / builderCanvasRect.width) * 100).toFixed(4))
        );
        renderH = String(
          Number(((rect.height / builderCanvasRect.height) * 100).toFixed(4))
        );
      }

      items.push({
        id: charm.variantId,
        quantity: 1,
        properties: {
          '_lt_design_id': designId,
          '_lt_role': 'charm',
          '_lt_hardware_color': hardware.color,
          '_lt_anchor_index': String(anchorIndex + 1),
          '_lt_anchor_x': String(Number(point.x)),
          '_lt_anchor_y': String(Number(point.y)),
          '_lt_path_t': pathT !== null ? String(pathT) : '',
          '_lt_rotation': pathT !== null
            ? String(outwardCharmRotation(pathT, charm))
            : String(Number(charm?.geometry?.rotationOffset || 0)),
          '_lt_connector_count': String(
            Math.max(
              1,
              Array.isArray(charm?.geometry?.connectors)
                ? charm.geometry.connectors.length
                : 1
            )
          ),
          '_lt_render_x': renderX,
          '_lt_render_y': renderY,
          '_lt_render_w': renderW,
          '_lt_render_h': renderH,
          '_lt_transparent_image': charm.image || '',
          '_lt_charm_title': charm.title || '',
          '_lt_design_image_url': designImageUrl
        }
      });
    });

    /*
      Assembly Service is a REAL Shopify product component.
      It is added ONCE for this specific design and uses the same design ID.
      No Assembly Service line = Cart Transform must leave the design loose.
    */
    if (state.assembly) {
      items.push({
        id: assemblyService.variantId,
        quantity: 1,
        properties: {
          '_lt_design_id': designId,
          '_lt_role': 'assembly',
          '_lt_hardware_color': hardware.color,
          '_lt_design_image_url': designImageUrl
        }
      });
    }

    if (hardware.rounding > 0 && roundingHardware) {
      items.push({
        id: roundingHardware.id,
        quantity: hardware.rounding,
        properties: {
          '_lt_system_hardware': 'true',
          '_lt_hardware_scope': designId,
          '_lt_hardware_kind': 'rounding',
          '_lt_hardware_color': hardware.color,
          '_lt_design_id': designId,
          '_lt_role': 'hardware',
          '_lt_design_image_url': designImageUrl
        }
      });
    }

    if (hardware.additional > 0 && additionalHardware) {
      items.push({
        id: additionalHardware.id,
        quantity: hardware.additional,
        properties: {
          '_lt_system_hardware': 'true',
          '_lt_hardware_scope': designId,
          '_lt_hardware_kind': 'additional',
          '_lt_hardware_color': hardware.color,
          '_lt_design_id': designId,
          '_lt_role': 'hardware',
          '_lt_design_image_url': designImageUrl
        }
      });
    }

    try {
      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result && (
            result.description ||
            result.message
          ) ||
          'Could not add the design to the cart.'
        );
      }

      let cart = null;

      try {
        cart = await fetch(`${root}cart.js`).then(r => r.json());
      } catch (e) {}

      /*
        Give the theme several common hooks it may listen for.
      */
      document.dispatchEvent(
        new CustomEvent(
          'lt-builder:cart-added',
          {
            detail: {
              designId,
              designImageUrl,
              manifest,
              result,
              cart,
              source: section
            }
          }
        )
      );

      /*
        Notify the Little Things cart drawer without firing generic theme cart
        events. Some Shrine/theme builds attach navigation behavior to generic
        cart:refresh/cart:updated events, which can send the customer to /cart
        even when "Redirect to cart after adding" is turned off.
      */
      document.dispatchEvent(
        new CustomEvent(
          'lt:cart-mutated',
          {
            bubbles: true,
            detail: { cart, designId, source: section }
          }
        )
      );

      setMessage('Your design was added to the bag.');
      setAddButtonLabel('Added ✓');

      if (redirectToCart) {
        window.location.assign(`${root}cart`);
        return;
      }

      setTimeout(() => {
        setAddButtonLabel(originalLabel);
        state.adding = false;
        updateUI();
      }, 1800);
    } catch (error) {
      console.error('[Little Things Builder]', error);

      setMessage(
        error && error.message
          ? error.message
          : 'Something went wrong while adding your design.',
        true
      );

      setAddButtonLabel(originalLabel);
      state.adding = false;
      updateUI();
    }
  }

  $('[data-add-to-cart]').addEventListener(
    'click',
    addDesignToCart
  );

  if (anchorSetupMode) {
    $('[data-copy-anchors]')?.addEventListener('click', async () => {
      const textarea = $('[data-anchor-json]');
      if (!textarea || !textarea.value) {
        setMessage('Choose a chain first.', true);
        return;
      }

      try {
        await navigator.clipboard.writeText(textarea.value);
        setMessage('Anchor JSON copied. Paste it into this chain product’s anchor-layout metafield.');
      } catch (e) {
        textarea.focus();
        textarea.select();

        try {
          document.execCommand('copy');
          setMessage('Anchor JSON copied. Paste it into the chain product metafield.');
        } catch (copyError) {
          setMessage('Select the JSON and copy it manually.', true);
        }
      }
    });

    $('[data-reset-anchors]')?.addEventListener('click', () => {
      if (!state.base) return;

      delete state.anchorDrafts[String(state.base.productId)];
      renderPreview();
      updateUI();
      setMessage('Anchors reset to the saved metafield layout (or generated defaults).');
    });
  }

  /*
    Save one final snapshot if the customer refreshes/navigates away.
  */
  window.addEventListener('pagehide', () => {
    saveCurrentDesign();
  });

  /*
    Initial render:
    restore the LAST active chain and every saved per-chain design first.
  */
  const restoredSavedDesign = hydrateSavedBuilderState();

  $$('[data-type]').forEach(item =>
    item.classList.toggle(
      'is-active',
      item.dataset.type === state.type
    )
  );

  renderStyles();
  renderFilter();
  renderPreview();
  updateUI();

  /*
    If there was no saved state, persist the builder's initial active chain so
    a refresh from this point forward returns to the same place.
  */
  if (!restoredSavedDesign) {
    saveCurrentDesign();
  }
  }

  function bootLittleThingsBuilders(root) {
    if (!root) return;
    if (root.matches?.('.ltsb[data-section-id]')) {
      initLittleThingsBuilder(root);
    }
    root.querySelectorAll?.('.ltsb[data-section-id]').forEach(initLittleThingsBuilder);
  }

  bootLittleThingsBuilders(document);
  document.addEventListener('shopify:section:load', event => {
    bootLittleThingsBuilders(event.target);
  });
})();
